<template>
    <div class="phd-risk-calculator">
                <div class="container">
                    <div class="row">
                        <div class="col-12 h-100">
                            <form @submit.prevent="hcmCalculatorFormula">
                                <div class="form-group row mt-5">
                                    <div class="col-4 col-form-label">
                                        Sex
                                    </div>
                                    <div class="col-8 pr-2 mt-2">
                                        <div
                                            class="btn-group btn-group-toggle"
                                            data-toggle="buttons">
                                            <label for="male">
                                                <input
                                                    type="radio"
                                                    name="male"
                                                    id="male"
                                                    autocomplete="off"
                                                    v-model.number="sex_range"
                                                    value="0"
                                                    checked
                                                    aria-describedby="male"/>
                                                Male
                                            </label>
                                            <label for="female" class="ml-4">
                                                <input
                                                    type="radio"
                                                    name="female"
                                                    id="female"
                                                    autocomplete="off"
                                                    v-model.number="sex_range"
                                                    value="1"
                                                    aria-describedby="female"/>
                                                Female
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row mb-4 align-items-center">
                                    <div class="col-12">
                                        <div class="col-6 pl-0 float-left">
                                            <label
                                                for="age"
                                                class="col-form-label"
                                                >Age
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="age"
                                                placeholder="30-79"
                                                v-model="age_range.value
                                                    "
                                                @blur="validateAge($event)"
                                                @input="handleUpperInput('year')"
                                                aria-describedby="ageyears"/>
                                            <p class="text-danger errorMessage" role="alert" v-if="ageValidation"> Age in years must be between 30-79 years</p>
                                            <i class="text-danger errorMessage" role = "alert" v-if="isAgeRequried">Please enter the patient’s age</i>
                                            <p class="toolTip mt-3" role="alert" v-if="ageIcon">Age must be between 30-79 years</p>
                                        </div>
                                        <div class="float-left clearfix lower">
                                            <p class="float-left" id="ageyears">
                                                years
                                            </p>
                                            <a
                                                class="ml-4  icon"
                                                @click="
                                                    validateAge('info')
                                                    "
                                                key="age-input">i</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row mb-4 align-items-center">
                                    <div class="col-12">
                                        <div class="col-6 pl-0 float-left">
                                            <label
                                                for="TotalCholesterol"
                                                class="col-form-label">
                                                <span class="abbr">
                                                    <div
                                                        title="Total Cholesterol">Total Cholesterol
                                                    </div>
                                                </span>
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="TotalCholesterol"
                                                placeholder="130-320"
                                                v-model="totalCholesterol_range.value"
                                                @blur="validateTotalCholesterol"
                                                @input="handleUpperInput('total')"
                                                aria-describedby="Total Cholesterol"/>
                                            <p class="text-danger errorMessage" role="alert" v-if="totalCholesterolRangeValidation">Total cholesterol levels can be fasting or non-fasting and must be between 130-320 mg/dL</p>
<i class="text-danger errorMessage" role="alert" v-if="istotalCholesterolRequired">Please enter the total cholesterol value</i>
                                              <p class="toolTip mt-3" role="alert" v-if="totalCholesteronIcon">Total cholesterol levels can be fasting or non-fasting and must be between 130-320 mg/dL</p>
                                        </div>
                                        <div class="float-left clearfix lower">
                                            <p class="float-left">
                                                <div
                                                    id="mg/dL"
                                                    title="mg/dl">mg/dL</div>
                                            </p>
                                        </div>
                                        <div class=" float-left clearfix lower"> 
                            <a  class="ml-4 icon" @click="validateTotalCholesterol('info')" key="lasize-input">i</a>
                          </div>
                                    </div>
                                </div>
                                <div class="form-row mb-4 align-items-center">
                                    <div class="col-12">
                                        <div class="col-6 pl-0 float-left">
                                            <label
                                                for="HDLCholesterol"
                                                class="col-form-label">
                                                <span
                                                    class="abbr"> <div title="HDL Cholesterol"
                                                        >HDL Cholesterol</div></span>
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="HDLCholesterol"
                                                placeholder="20-100"
                                                v-model="hdlCholesteron_range.value"
                                                @blur="hdlCholesteronValidation"
                                                @input="handleUpperInput('hdl')"
                                                aria-describedby="HDL Cholesterol"/>
                                            <p class="text-danger errorMessage" role="alert" v-if="hdlCholesteronValidate">HDL cholesterol levels can be fasting or non-fasting and must be between 20-100 mg/dL</p>
                                               <i class="text-danger errorMessage" role="alert" v-if="ishdlCholesteronRequired">Please enter the HDL cholesterol value</i>
                                                 <p class="toolTip mt-3" role="alert" v-if="hdlCholesteronIcon">HDL cholesterol levels can be fasting or non-fasting and must be between 20-100 mg/dL</p>
                                        </div>
                                        <div class=" float-left clearfix lower">
                                            <span class="float-left">mg/dL</span>
                                            <a
                                                class="ml-4 icon"
                                                @click="
                                                    hdlCholesteronValidation('info')
                                                    "
                                                key="lasize-input"
                                                >i</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row mb-0 align-items-center">
                                    <div class="col-12">
                                        <div class="col-6 pl-0 float-left">
                                            <label
                                                for="SBPvalue"
                                                class="col-form-label">
                                                <span
                                                    class="abbr"
                                                    ><div
                                                        title="SBP value"
                                                        >SBP</div></span></label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="SBPvalue"
                                                placeholder="90-200"
                                                v-model="sbp_range.value"
                                                @blur="sbpValidation"
                                                @input="handleUpperInput('sbp')"
                                                aria-describedby="SBP value"/>
                                            <p
                                                class="text-danger errorMessage"
                                                role="alert"
                                                v-if="spbValidate">
                                                Systolic blood pressure must be between 90-200 mmHg
                                            </p>
                                            <i
                                                class="text-danger errorMessage"
                                                role="alert"
                                                v-if="isSbpRequired">
                                                Please enter the SBP value
                                            </i>
                                            <p class="toolTip  mt-3" role="alert" v-if="sbpIcon">Systolic blood pressure must be between 90-200 mmHg</p>
                                        </div>
                                        <div class=" float-left clearfix lower">
                                            <span class="abbr float-left">
                                                <div
                                                    id="mmHg-value"
                                                    title="mmHg ">mmHg</div>
                                            </span>
                                            <a
                                               
                                                class="ml-4 icon"
                                                @click="
                                                    sbpValidation('info')
                                                    "
                                                key="maxlvot-input">i</a>
                                        </div>
                                    </div>
                                </div>
                                <div class=" mt-4">
                                    <!-- Started deplyment -->
                                    <div
                                        class="form-row mb-4 align-items-center">
                                        <div class="col-12">
                                            <div class="col-6 pl-0 float-left">
                                                <label
                                                    for="BMI"
                                                    class="col-form-label text-uppercase">
                                                    <span class="abbr">
                                                        <div
                                                            title="BMI">BMI
                                                        </div>
                                                    </span>
                                                </label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="BMI"
                                                    placeholder="18.5-39.9"
                                                    v-model="bmi_range.value"
                                                    @blur="BMIValidation"
                                                    aria-describedby="BMI-value"
                                                    @input="handleUpperInput('bmi')"/>
                                                <p
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="validationBMI">
                                                    Body mass index (BMI) must be between 18.5 - 39.9 kg/m&#178
                                                   
                                                </p> 
                                                <i
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="isbmiRequired">
                                                    Please enter the BMI value
                                                </i>
                                                <p class="toolTip  mt-3" role="alert" v-if="bmiIcon">Body mass index (BMI) must be between 18.5 - 39.9 kg/m&#178</p>
                                            </div>
                                            <div class=" float-left clearfix lower"> 
                            <a  class="ml-4 icon" @click="BMIValidation('info')" key="lasize-input">i</a>
                          </div>
                                        </div>
                                    </div>
                                    <!--Deoployment -->
                                    <div
                                        class="form-row mb-4 align-items-center">
                                        <div class="col-12">
                                            <div class="col-6 pl-0 float-left">
                                                <label
                                                    for="eGFR"
                                                    class="col-form-label">
                                                    <span class="abbr">
                                                        <div
                                                            title="eGFR">eGFR
                                                        </div>
                                                    </span>
                                                </label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="eGFR"
                                                    placeholder="15-140"
                                                    v-model="egfr_range.value"
                                                    @blur = "egfrValidation"
                                                    aria-describedby="eGFR-value"
                                                    @input="handleUpperInput('efgr')"
                                                    />
                                                <p
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="validationegfr">
                                                    Estimated glomerular filtration rate (eGFR) must be between 15 - 140 ml/min/1.73m<sup>2</sup>
                                                </p>
                                                <i
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="isegfrRequired">
                                                     Please enter the eGFR value
                                                </i>
                                                <p class="toolTip  mt-3" role="alert" v-if="egfrIcon"> Estimated glomerular filtration rate (eGFR) must be between 15 - 140 ml/min/1.73m<sup>2</sup></p>
                                            </div>
                                            <div class=" float-left clearfix lower"> 
                            <span class="abbr float-left"> 
                              </span> 
                              <a  class="ml-4 icon" @click="egfrValidation('info')" key="maxlvot-input">i</a>
                          </div>
                                        </div>
                                    </div>
                                    <!-- //diabetes -->
                                    <div class="form-group row">
                                        <div
                                            class="col-4 col-form-label ">
                                            <span class="abbr">
                                                <label
                                                    id="Diabetes"
                                                    title="Diabetes"
                                                    for="Diabetes"
                                                    >Diabetes</label>
                                            </span>
                                        </div>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="NoDiabetes">
                                                    <input
                                                        type="radio"
                                                        name="NoDiabetes"
                                                        id="NoDiabetes"
                                                        autocomplete="off"
                                                        v-model.number="diabetes_range
                                                            "
                                                            aria-label="Diabetes No"
                                                        value="0"
                                                        checked
                                                        aria-describedby="No Diabetes" />
                                                    No
                                                </label>
                                                <label
                                                    for="yesDiabetes"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="yesDiabetes"
                                                        id="yesDiabetes"
                                                        autocomplete="off"
                                                        aria-label="Diabetes Yes"
                                                        v-model.number="diabetes_range"
                                                        value="1"
                                                        aria-describedby="yesDiabetes"/>
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="
                                                        alertMessage('diabetes')
                                                        "
                                                    key="unexsy-input">i</a>
                                            </div>
                                        </div>
                                        <p class="toolTip col-6 mt-3 custom-tooltip" role="alert" v-if="diabetesIcon">{{ diabetesErrorMessage }}</p>
                                    </div>
                                    <div class="form-group row">
                                        <div
                                            class="col-4 col-form-label">
                                            <span class="abbr">
                                                <label
                                                    id="abbrnsvt"
                                                    title="Current Smoking"
                                                    for="Current Smoking"
                                                    >Current Smoking</label>
                                            </span>
                                        </div>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="CurrentSmoker_no">
                                                    <input
                                                        type="radio"
                                                        name="CurrentSmoker_no"
                                                        id="CurrentSmoker_no"
                                                        autocomplete="off"
                                                        aria-label="Current Smoker No"
                                                        v-model.number="currentSmoker_range"
                                                        value="0"
                                                        checked
                                                        aria-describedby="CurrentSmoker no"/>
                                                    No
                                                </label>
                                                <label
                                                    for="CurrentSmoker_yes"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="CurrentSmoker_yes"
                                                        id="CurrentSmoker_yes"
                                                        aria-label="Current Smoker Yes"
                                                        autocomplete="off"
                                                        v-model.number="currentSmoker_range"
                                                        value="1"
                                                        aria-describedby="CurrentSmoker_yes"/>
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="
                                                        alertMessage('currentSmoker')
                                                        "
                                                    key="unexsy-input">i</a>
                                            </div>
                                        </div>
                                        <p class="toolTip col-6 mt-3 custom-tooltip" role="alert" v-if="currentSmokerIcon">{{ currentSmokerErrorMessage }}</p>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-4 col-form-label" for="Anti-hypertensive medication">
                                            Anti-hypertensive medication
                                        </label>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="Anti_hypertensive_medication_no">
                                                    <input
                                                        type="radio"
                                                        name="Anti_hypertensive_medication_no"
                                                        id="Anti_hypertensive_medication_no"
                                                        autocomplete="off"
                                                        v-model.number="htmlmeds_range
                                                            "
                                                            aria-label="Anti hypertensive medication No"
                                                        value="0"
                                                        checked/>
                                                    No
                                                </label>
                                                <label
                                                    for="Anti_hypertensive_medication_yes"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="Anti_hypertensive_medication_yes"
                                                        id="Anti_hypertensive_medication_yes"
                                                        autocomplete="off"
                                                        aria-label="Anti hypertensive medication Yes"
                                                        v-model.number="htmlmeds_range
                                                            "
                                                        value="1"/>
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="
                                                        alertMessage('htnMeds')
                                                        "
                                                    key="unexsy-input">i</a>
                                            </div>
                                        </div>
                                        <p class="toolTip col-6 mt-3 custom-tooltip" role="alert" v-if="htnMedsIcon">{{ htnMedsErrorMessage }}</p>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-4 col-form-label" for ="Lipid-lowering medication">
                                            Lipid-lowering medication
                                        </label>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="Cholesterol treated with a statin
                                            medication_no">
                                                    <input
                                                        type="radio"
                                                        name="Cholesterol treated with a statin
                                            medication"
                                                        id="Cholesterol treated with a statin
                                            medication_no"
                                            aria-label="Cholesterol treated with a statin
                                            medication No"
                                                        autocomplete="off"
                                                        v-model.number="cholesteronTreated_range
                                                            "
                                                        value="0"
                                                        checked/>
                                                    No
                                                </label>
                                                <label
                                                    for="Cholesterol treated with a statin
                                            medication_yes"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="Cholesterol treated with a statin
                                            medication"
                                                        id="Cholesterol treated with a statin
                                            medication_yes"
                                            aria-label="Cholesterol treated with a statin
                                            medication Yes"
                                                        autocomplete="off"
                                                        v-model.number="cholesteronTreated_range"
                                                        value="1"/>
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="
                                                        alertMessage('ds')
                                                        "
                                                    key="apan-input">i</a>
                                            </div>
                                        </div>
                                        <p class="toolTip col-6 mt-3 custom-tooltip" role="alert" v-if="cholesteronTreatedIcon">{{ CholesteroltreatedErrorMessage }}</p>
                                    </div>
                                    <div class="form-group row">
                                        <div class = "col-6 col-form-label">
                                        <b>The following three predictors are optional for further personalization of risk assessment. When they are clinically indicated or available, please click on yes and enter the value</b>
                                    </div>
                                    </div>
                                    <!-- UACR -->
                                    <div class="form-group row">
                                        <div
                                            class="col-4 col-form-label ">
                                            <span class="abbr">
                                                <label
                                                    id="UACR"
                                                    title="UACR"
                                                    for="uacr"
                                                    >UACR</label>
                                            </span>
                                        </div>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="UACR_no">
                                                    <input
                                                        type="radio"
                                                        name="UACR"
                                                        id="UACR_NO"
                                                        aria-label="UACR No"
                                                        autocomplete="off"
                                                        v-model.number="isShowUACR
                                                            "
                                                        value="0"
                                                        checked
                                                        @click = "resetTheValueOnceUserYesOrNo('uacr')"
                                                        />
                                                    No
                                                </label>
                                                <label
                                                    for="UACR_yes"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="UACR"
                                                        id="UACR_Yes"
                                                        aria-label="UACR Yes"
                                                        autocomplete="off"
                                                        v-model.number="isShowUACR"
                                                        value="1"
                                                        @click = "resetTheValueOnceUserYesOrNo('uacr')"
                                                        />
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="latestIconsValidation('uacr')"
                                                    key="unexsy-input">i</a>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if = "isShowUACR == 1">
                                        <div class="col-6 pl-0 float-left ">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    id="UACR_Yes"
                                                    placeholder="0 to 25000"
                                                    v-model="uacr_range_front_end"
                                                    @blur = "latestValidation('uacr', $event)"
                                                    @input="handleInput('uacr')"
                                                    />
                                                    <p
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="uacrValidation">
                                                    UACR must be between 0 - 25000 mg/g
                                                </p>
                                                <i
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="emptyUacrValidation">
                                                    Please enter the UACR value
                                                </i>
                                                <!-- <p class="toolTip mt-3" role="alert" v-if="iconUacrValidation"> UACR must be between 0 - 25000 mg/g</p> -->
                                        </div>
                                        <span class="abbr float-left mt-2">
                                                <div
                                                    id="mmHg-value"
                                                    title="mmHg ">mg/g</div>
                                            </span>
                                    </div>
                                        <p class="toolTip col-6 mt-3 custom-tooltip" role="alert" v-if="iconUacrValidation"> UACR is clinically indicated for individuals with chronic kidney disease, diabetes, or hypertension</p>
                                    </div>
                                    <!--HBA1C-->
                                    <div class="form-group row">
                                        <div
                                            class="col-4 col-form-label ">
                                            <span class="abbr">
                                                <label
                                                    id="HbA1C"
                                                    title="HbA1C"
                                                    for="hba1c"
                                                    >HbA1C</label>
                                            </span>
                                        </div>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="HbA1C_no">
                                                    <input
                                                        type="radio"
                                                        name="HbA1C"
                                                        id="HbA1C_No"
                                                        aria-label="HbA1C No"
                                                        autocomplete="off"
                                                        v-model.number="isShowHbA1C
                                                            "
                                                        value="0"
                                                        checked
                                                        @click = "resetTheValueOnceUserYesOrNo('hba1c')"
                                                        />
                                                    No
                                                </label>
                                                <label
                                                    for="hhba1c_Yesba1c"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="hba1c"
                                                        id="hba1c_Yes"
                                                        aria-label="hba1c Yes"
                                                        autocomplete="off"
                                                        v-model.number="isShowHbA1C"
                                                        value="1"
                                                        @click = "resetTheValueOnceUserYesOrNo('hba1c')"
                                                        />
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="latestIconsValidation('HbA1C')"
                                                    key="unexsy-input">i</a>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if = "isShowHbA1C == 1">
                                        <div class="col-6 pl-0 float-left ">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    id="HbA1C"
                                                    placeholder="3 to 15"
                                                    v-model="HbA1C_range"
                                                    @blur = "latestValidation('HbA1C')"
                                                    @input="handleInput('hb')"

                                                    />
                                                    <p
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="HbA1CValidation">
                                                    HbA1C must be between 3% - 15%
                                                </p>
                                                <i
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="emptyHbA1CValidation">
                                                    Please enter the HbA1C value
                                                </i>
                                        </div>
                                        <span class="abbr float-left mt-2">
                                                <div
                                                    id="mmHg-value"
                                                    title="mmHg ">%</div>
                                            </span>
                                    </div>
                                        <p class="toolTip mt-3 col-6 custom-tooltip" role="alert" v-if="iconHbA1CValidation">HbA1c is clinically indicated for individuals with diabetes, prediabetes, overweight, or obesity, or those with history of gestational diabetes</p>
                                    </div>
                                      <!--SID-->
                                      <div class="form-group row">
                                        <div
                                            class="col-4 col-form-label ">
                                            <span class="abbr">
                                                <label
                                                    title="SID"
                                                    for = "Zip Code (for estimating social deprivation index [SDI])"
                                                    >Zip Code (for estimating social deprivation index [SDI])</label>
                                            </span>
                                        </div>
                                        <div class="col-8 pr-2 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle"
                                                data-toggle="buttons">
                                                <label for="SID_no">
                                                    <input
                                                        type="radio"
                                                        name="SID"
                                                        id="SID_No"
                                                        autocomplete="off"
                                                        aria-label="Zip Code No"
                                                        v-model.number="isShowSID
                                                            "
                                                        value="0"
                                                        checked
                                                        @click = "resetTheValueOnceUserYesOrNo('sid')"
                                                        
                                                        />
                                                    No
                                                </label>
                                                <label
                                                    for="SID_yes"
                                                    class="ml-4">
                                                    <input
                                                        type="radio"
                                                        name="SID"
                                                        id="SID_Yes"
                                                        aria-label="Zip Code Yes"
                                                        autocomplete="off"
                                                        v-model.number="isShowSID"
                                                        value="1"
                                                        @click = "resetTheValueOnceUserYesOrNo('sid')"
                                                        />
                                                    Yes
                                                </label>
                                                <a
                                                    class="ml-4 icon"
                                                    @click="latestIconsValidation('sid')"
                                                    key="unexsy-input">i</a>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if = "isShowSID == 1">
                                        <div class="col-6 pl-0 float-left ">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    id="SID"
                                                    placeholder="Enter zip code"
                                                    v-model="SID_range"
                                                    @blur = "latestValidation('sid', $event)"
                                                    maxlength = "5"
                                                    @input="handleInput('SID_range')"
 />
                                                    <i class="text-danger errorMessage" role="alert" v-if="SIDValidation">
                                                        Please enter a valid 5 digit zip code or click no that this information is not available
                                                    </i>
                                                <i
                                                    class="text-danger errorMessage"
                                                    role="alert"
                                                    v-if="emptySIDValidation">
                                                    Please enter a valid 5 digit zip code or click no that this information is not available
                                                </i>
                                        </div>
                                    </div>
                                        <p class="toolTip col-6 mt-3 custom-tooltip" role="alert" v-if="iconSIDValidation">A valid 5-digit zip code is needed to estimate social deprivation index [SDI]</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div v-if="isLoading"
                                        class="col col-md-12 text-center text-lg-left">
                                        <button
                                            class="btn btn-primary"
                                          
                                            type="button"
                                            value="loadong"
                                             disabled>
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                        </button>
                                        <input
                                            class="btn btn-outline ml-3"
                                            @click="resetForm"
                                            type="reset"
                                            key="reset"
                                            value="Reset"/>
                                    </div>
                                    <div v-else
                                        class="col col-md-12 text-center text-lg-left">
                                        <input
                                            class="btn btn-primary"
                                            @click="formValidate"
                                            type="submit"
                                            value="Calculate"
                                            key="submit"/>
                                        <input
                                            class="btn btn-outline ml-3"
                                            @click="resetForm"
                                            type="reset"
                                            key="reset"
                                            value="Reset"/>
                                    </div>
                                </div>  
                            </form>
                            <div class="form-group row">
                                        <div class="col-xs-12 col-12 mt-2">
                                            <div
                                                class="btn-group btn-group-toggle col-xs-12 "
                                                data-toggle="buttons">
                                                <label class=" col-xs-12 mb-2 mr-4" for=" RiskofCVD">
                                                    <input
                                                        type="radio"
                                                        name=" Risk of CVD"
                                                        id=" RiskofCVD"
                                                        autocomplete="off"
                                                        v-model.number="totalResult
                                                            "
                                                        value="0"
                                                        checked/>
                                                        Risk of CVD
                                                </label>
                                                <label
                                                    for="RiskofASCVD"
                                                    class=" col-xs-12 mb-2 mr-4">
                                                    <input
                                                        type="radio"
                                                        name="RiskofASCVD"
                                                        id="RiskofASCVD"
                                                        autocomplete="off"
                                                        v-model.number="totalResult
                                                            "
                                                        value="1"/>
                                                        Risk of ASCVD
                                                </label>
                                                <label
                                                    for="RiskofHeartFailure"
                                                    class=" col-xs-12 mb-2">
                                                    <input
                                                        type="radio"
                                                        name="RiskofHeartFailure"
                                                        id="RiskofHeartFailure"
                                                        autocomplete="off"
                                                        v-model.number="totalResult
                                                            "
                                                        value="2"/>
                                                        Risk of Heart Failure
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if = "sex_range === 0 && totalValidation" id="targetElement">
                                    <div v-if = "totalResult == 0" class = "custom-space-result" id="targetElement">
                                        <!-- totalCVDMenValue -->
                                        <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 10-year risk of CVD</sup> = {{ totalCVDMenValue }}%</label> <br/>
                                            <!-- <div class = "normalClass" v-if = "totalCVDMenValue === ''">
                                                 <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDMenValue }}%</label> <br/>
                                            </div>
                                            <div class = "greenClass" v-else-if = "totalCVDMenValue < 5">
                                                 <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDMenValue }}%</label> <br/>
                                            </div>
                                            <div class = "redClass" v-else-if = "totalCVDMenValue > 20">
                                                 <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDMenValue }}%</label> <br/>
                                            </div>
                                            <div class = "oragneClass" v-else-if = "totalCVDMenValue > 5 && totalCVDMenValue < 7.4">
                                                 <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDMenValue }}%</label> <br/>
                                            </div>
                                            <div class = "lightRedClass" v-else-if = "totalCVDMenValue > 7.5 && totalCVDMenValue < 19.9">
                                                 <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDMenValue }}%</label> <br/>
                                            </div> -->
                                            <!-- thrityYearsCVDMen -->
                                            <div v-if = "age_range.value < 60">
                                                <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 30-year risk of CVD</sup> = {{ thrityYearsCVDMen }}% </label>
                                                    <!-- <div class = "normalClass" v-if = "thrityYearsCVDMen === ''">
                                                        <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ thrityYearsCVDMen }}% </label>
                                                    </div>
                                                    <div class = "greenClass" v-else-if = "thrityYearsCVDMen < 5">
                                                        <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ thrityYearsCVDMen }}% </label>
                                                    </div>
                                                    <div class = "redClass" v-else-if = "thrityYearsCVDMen > 20">
                                                        <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ thrityYearsCVDMen }}% </label>
                                                    </div>
                                                    <div class = "oragneClass" v-else-if = "thrityYearsCVDMen > 5 && thrityYearsCVDMen > 7.4">
                                                        <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ thrityYearsCVDMen }}% </label>
                                                    </div>
                                                    <div class = "lightRedClass" v-else-if = "thrityYearsCVDMen > 7.5 && thrityYearsCVDMen < 19.9">
                                                        <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ thrityYearsCVDMen }}% </label>
                                                    </div> -->
                                            </div>  
                                        </div>
                                    <!-- totalAscdMenValue -->
                                    <div v-if = "totalResult == 1" class = "custom-space-result" id="targetElement">
                                        <label for="risk" class="col-form-label font-weight-bold">This individual has an estimated 10-year risk of ASCVD</sup> = {{ totalAscdMenValue }}% </label> <br/>
                                        <!-- <div class = "normalClass" v-if="totalAscdMenValue === ''">
                                            <label for="risk" class="col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdMenValue }}% </label> <br/>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalAscdMenValue < 5">
                                            <label for="risk" class="col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdMenValue }}% </label> <br/>
                                        </div>
                                        <div class = "redClass" v-else-if="totalAscdMenValue > 20">
                                            <label for="risk" class="col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdMenValue }}% </label> <br/>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalAscdMenValue > 5 && totalAscdMenValue < 7.4">
                                            <label for="risk" class="col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdMenValue }}% </label> <br/>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalAscdMenValue > 7.5 && totalAscdMenValue < 19.9">
                                            <label for="risk" class="col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdMenValue }}% </label> <br/>
                                        </div> -->
                                        <!-- totalThirtyAscvdMenValue -->
                                        <div v-if = "age_range.value < 60">
                                            <label for="risk" class="col-form-label font-weight-bold">This individual has an estimated 30-year risk of ASCVD</sup> = {{ totalThirtyAscvdMenValue }}% </label>
                                        <!-- <div class = "normalClass" v-if="totalThirtyAscvdMenValue === ''">
                                             <label for="risk" class="col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdMenValue  }}% </label>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalThirtyAscvdMenValue < 5">
                                             <label for="risk" class="col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdMenValue  }}% </label>
                                        </div>
                                        <div class = "redClass" v-else-if="totalThirtyAscvdMenValue > 20">
                                             <label for="risk" class="col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdMenValue  }}% </label>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalThirtyAscvdMenValue > 5 && totalThirtyAscvdMenValue < 7.4">
                                             <label for="risk" class="col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdMenValue  }}% </label>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalThirtyAscvdMenValue > 7.5 && totalThirtyAscvdMenValue < 19.9">
                                             <label for="risk" class="col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdMenValue  }}% </label>
                                        </div> -->
                                        </div>
                                    </div>
                                    <!-- totalHearFailureMenVlaue -->
                                    <div v-if = "totalResult == 2" class = "custom-space-result" id="targetElement">
                                        <label for="risk" class=" col-form-label font-weight-bold"> This individual has an estimated 10-year risk of Heart Failure</sup> = {{ totalHearFailureMenVlaue }}% </label> <br/>
                                        <!-- <div class = "normalClass" v-if="totalHearFailureMenVlaue === ''">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHearFailureMenVlaue }}% </label> <br/>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalHearFailureMenVlaue < 5">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHearFailureMenVlaue }}% </label> <br/>
                                        </div>
                                        <div class = "redClass" v-else-if="totalHearFailureMenVlaue > 20">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHearFailureMenVlaue }}% </label> <br/>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalHearFailureMenVlaue > 5 && totalHearFailureMenVlaue < 7.4">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHearFailureMenVlaue }}% </label> <br/>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalHearFailureMenVlaue > 7.5 && totalHearFailureMenVlaue < 19.9">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHearFailureMenVlaue }}% </label> <br/>
                                        </div> -->
                                        <!-- totalThirtyHearFailureMenValue -->
                                        <div v-if = "age_range.value < 60">
                                            <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 30-year risk of Heart Failure</sup> = {{ totalThirtyHearFailureMenValue }}% </label>
                                        <!-- <div class = "normalClass" v-if="totalThirtyHearFailureMenValue === ''">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyHearFailureMenValue  }}% </label>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalThirtyHearFailureMenValue < 5">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyHearFailureMenValue  }}% </label>
                                        </div>
                                        <div class = "redClass" v-else-if="totalThirtyHearFailureMenValue > 20">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyHearFailureMenValue  }}% </label>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalThirtyHearFailureMenValue > 5 && totalThirtyHearFailureMenValue < 7.4">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyHearFailureMenValue  }}% </label>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalThirtyHearFailureMenValue > 7.5 && totalThirtyHearFailureMenValue < 19.9">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyHearFailureMenValue  }}% </label>
                                        </div> -->
                                    </div>
                                    </div>
                                </div>
                                <div v-if = "sex_range === 1 && totalValidation" id="targetElement">
                                    <div v-if = "totalResult == 0" class = "custom-space-result">
                                        <!-- totalCVDWomenValue -->
                                        <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 10-year risk of CVD</sup> = {{ totalCVDWomenValue }}%</label>
                                        <!-- <div class = "normalClass" v-if="totalCVDWomenValue === ''">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDWomenValue  }}%</label>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalCVDWomenValue < 5" >
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDWomenValue  }}%</label>
                                        </div>
                                        <div class = "redClass" v-else-if="totalCVDWomenValue >20" >
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDWomenValue  }}%</label>
                                        </div>
                                        <div class = "oragneClass " v-else-if="totalCVDWomenValue > 5 && totalCVDWomenValue < 7.4" >
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDWomenValue  }}%</label>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalCVDWomenValue > 7.5 && totalCVDWomenValue < 19.9" >
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of CVD:</sup> = {{ totalCVDWomenValue  }}%</label>
                                        </div> -->
                                        <!-- totalThirtyYearsCVDWomenValue -->
                                        <div v-if = "age_range.value < 60">
                                            <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 30-year risk of CVD</sup> = {{ totalThirtyYearsCVDWomenValue }}% </label>
                                            <!-- <div class = "normalClass" v-if="totalThirtyYearsCVDWomenValue === ''">
                                                    <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ totalThirtyYearsCVDWomenValue }}% </label>
                                            </div>
                                            <div class = "greenClass" v-else-if="totalThirtyYearsCVDWomenValue < 5">
                                                    <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ totalThirtyYearsCVDWomenValue }}% </label>
                                            </div>
                                            <div class = "redClass" v-else-if="totalThirtyYearsCVDWomenValue > 20">
                                                    <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ totalThirtyYearsCVDWomenValue }}% </label>
                                            </div>
                                            <div class = "oragneClass" v-else-if="totalThirtyYearsCVDWomenValue > 5 && totalThirtyYearsCVDWomenValue < 7.4">
                                                    <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ totalThirtyYearsCVDWomenValue }}% </label>
                                            </div>
                                            <div class = "lightRedClass" v-else-if="totalThirtyYearsCVDWomenValue > 7.5 && totalThirtyYearsCVDWomenValue < 19.9">
                                                    <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of CVD:</sup> = {{ totalThirtyYearsCVDWomenValue }}% </label>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div v-if = "totalResult == 1" class = "custom-space-result">
                                        <!-- //totalAscdWomenValue -->
                                        <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 10-year risk of ASCVD</sup> = {{ totalAscdWomenValue }}% </label> <br/>
                                        <!-- <div class = "normalClass" v-if="totalAscdWomenValue === ''">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalAscdWomenValue < 5">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "redClass" v-else-if="totalAscdWomenValue > 20">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalAscdWomenValue  > 5 && totalAscdWomenValue  < 7.4">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalAscdWomenValue  > 7.5 && totalAscdWomenValue  < 19.9">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 10-year risk of ASCVD:</sup> = {{ totalAscdWomenValue }}% </label> <br/>
                                        </div> -->
                                        <!-- totalThirtyAscvdWomenValue -->
                                        <div v-if = "age_range.value < 60">
                                            <label for="risk" class="col-form-label font-weight-bold">This individual has an estimated 30-year risk of ASCVD</sup> = {{ totalThirtyAscvdWomenValue }}% </label>
                                        <!-- <div class = "normalClass" v-if="totalThirtyAscvdWomenValue === ''">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdWomenValue  }}% </label>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalThirtyAscvdWomenValue < 5">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdWomenValue  }}% </label>
                                        </div>
                                        <div class = "redClass" v-else-if="totalThirtyAscvdWomenValue > 20">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdWomenValue  }}% </label>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalThirtyAscvdWomenValue > 5 && totalThirtyAscvdWomenValue < 7.4">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdWomenValue  }}% </label>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalThirtyAscvdWomenValue > 7.5 && totalThirtyAscvdWomenValue < 19.9">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of ASCVD:</sup> = {{ totalThirtyAscvdWomenValue  }}% </label>
                                        </div> -->
                                    </div>
                                    </div>
                                    <div v-if = "totalResult == 2" class = "custom-space-result">
                                        <label for="risk" class=" col-form-label font-weight-bold"> This individual has an estimated 10-year risk of Heart Failure</sup> = {{ totalHeartFailureWomenValues }}% </label> <br/>
                                        <!-- <div class = "normalClass" v-if="totalHeartFailureWomenValue === ''">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHeartFailureWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "greenClass" v-else-if="totalHeartFailureWomenValue < 5">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHeartFailureWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "redClass" v-else-if="totalHeartFailureWomenValue > 20">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHeartFailureWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "oragneClass" v-else-if="totalHeartFailureWomenValue > 5 && totalHeartFailureWomenValue < 7.4">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHeartFailureWomenValue }}% </label> <br/>
                                        </div>
                                        <div class = "lightRedClass" v-else-if="totalHeartFailureWomenValue > 7.5 && totalHeartFailureWomenValue < 19.9">
                                            <label for="risk" class=" col-form-label"> This individual has an estimated 10-year risk of Heart Failure:</sup> = {{ totalHeartFailureWomenValue }}% </label> <br/>
                                        </div> -->
                                        <!-- totalThirtyYearsHeartFailureWomen -->
                                        <div v-if = "age_range.value < 60">
                                            <label for="risk" class=" col-form-label font-weight-bold">This individual has an estimated 30-year risk of Heart Failure</sup> = {{ totalThirtyYearsHeartFailureWomen }}% </label>
                                        <!-- <div class = "normalClass" v-if="totalThirtyYearsHeartFailureWomen === ''">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyYearsHeartFailureWomen  }}% </label>
                                      </div>
                                      <div class = "greenClass" v-else-if="totalThirtyYearsHeartFailureWomen < 5">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyYearsHeartFailureWomen  }}% </label>
                                      </div>
                                      <div class = "redClass" v-else-if="totalThirtyYearsHeartFailureWomen > 20">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyYearsHeartFailureWomen  }}% </label>
                                      </div>
                                      <div class = "oragneClass" v-else-if="totalThirtyYearsHeartFailureWomen > 5 && totalThirtyYearsHeartFailureWomen < 7.4">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyYearsHeartFailureWomen  }}% </label>
                                      </div>
                                      <div class = "lightRedClass" v-else-if="totalThirtyYearsHeartFailureWomen > 7.5 && totalThirtyYearsHeartFailureWomen < 19.9">
                                            <label for="risk" class=" col-form-label">This individual has an estimated 30-year risk of Heart Failure:</sup> = {{ totalThirtyYearsHeartFailureWomen  }}% </label>
                                      </div> -->
                                    </div>
                                    </div>
                                   
                                </div>
                                <div v-if = "totalValidation" class = "modalName">The risk estimates were calculated using the {{ ModelName }}</div>
                        </div>
                        <!-- <div class="loader-container" :class="{ 'show': isLoading }" role="alert" aria-live="assertive">
                           <div class="loader">Loading...</div>
                       </div> -->
                    </div>
                </div>
                
            </div>
  </template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            sex_range: 0,
            age_range: {
                value: '',
                errorMessage: "Age in years must be between 30-79 years",
                requiredMessage: "Please enter your Age"
            },
            totalCholesterol_range: {
                value: "",
                errorMessage: "Total cholesterol must be between 130-320 mg/dL",
                requiredMessage: "Please enter the cholesterol value"
            },
            hdlCholesteron_range: {
                value: "",
                errorMessage: "HDL cholesterol must be between 20 to 100 mg/dL",
                requiredMessage: "Please enter the HDL cholesterol value"
            },
            sbp_range: {
                value: "",
                errorMessage: "Systolic blood pressure must be between 90-200 mm Hg",
                requiredMessage: "Please enter the SBP value"
            },
            diabetes_range: 0,
            currentSmoker_range: 0,
            bmi_range: {
                value: "",
                errorMessage: "Body Mass Index (BMI) must be between 18.5 - 39.9 kg/m",
                requiredMessage: "Please enter the Body mass index (BMI) value"
            },
            egfr_range: {
                value: "",
                errorMessage: "Estimated glomerular filtration rate (eGFR) may be between 15 - 140 ml.",
                requiredMessage: "Pelase enter the Estimated glomerular filtration rate (eGFR) value"
            },
            htmlmeds_range: 0,
            htn_range: 0,
            cholesteronTreated_range: 0,
            uacr_range: "",
            uacr_range_front_end: '',
            HbA1C_range: '',
            SID_range: '',
            totalCVDWomenValue: "",
            totalCVDMenValue: "",
            totalAscdWomenValue: "",
            totalAscdMenValue: "",
            totalHearFailureMenVlaue: "",
            totalHeartFailureWomenValues: "",
            totalHeartFailureThirtyValueWomenValue: "",
            ageValidation: false,
            totalCholesterolRangeValidation: false,
            hdlCholesteronValidate: false,
            spbValidate: false,
            validationBMI: false,
            validationegfr: false,
            isAgeRequried: false,
            istotalCholesterolRequired: false,
            ishdlCholesteronRequired: false,
            isSbpRequired: false,
            isbmiRequired: false,
            isegfrRequired: false,
            ageIcon: false,
            totalCholesteronIcon: false,
            hdlCholesteronIcon: false,
            sbpIcon: false,
            bmiIcon: false,
            egfrIcon: false,
            activeItem: 'premier',
            tierId: null,
            totalThirtyYearsHeartFailureWomen: "",
            totalThirtyAscvdWomenValue: "",
            totalThirtyYearsCVDWomenValue: "",
            totalThirtyHearFailureMenValue: "",
            totalThirtyAscvdMenValue: "",
            thrityYearsCVDMen: "",
            totalResult: 0,
            diabetesErrorMessage: "Any history of diabetes.",
            currentSmokerErrorMessage: "Any cigarette use within the last 30 days",
            htnMedsErrorMessage: "Current use of any medication for hypertension",
            CholesteroltreatedErrorMessage: "Current use of statin medication to lower cholesterol",
            diabetesIcon: false,
            currentSmokerIcon: false,
            htnMedsIcon: false,
            cholesteronTreatedIcon: false,
            totalValidation: false,
            mobile: window.innerWidth <= 700,
            uacrValidation: false,
            HbA1CValidation: false,
            SIDValidation: false,
            emptyUacrValidation: false,
            emptyHbA1CValidation: false,
            emptySIDValidation: false,
            iconUacrValidation: false,
            iconHbA1CValidation: false,
            iconSIDValidation: false,
            SDIAPIValue: -1,
            sdiZipCode: {
                URL: "/aha-service/PHDApi/GetSdiValueByZipcode",
                default: "",
                upgrade: "",
            },
            isShowSID: 0,
            isShowHbA1C: 0,
            isShowUACR: 0,
            SDIMissing: 1,
            ModelName: "",
            isLoading: false
        };
    },
    methods: {
        handleUpperInput(inputKey) {
            if (inputKey === 'bmi') {
                this.bmi_range.value = this.bmi_range.value.replace(/[^0-9.]/g, "");
            } 
             if (inputKey === 'efgr') {
                this.egfr_range.value = this.egfr_range.value.replace(/[^0-9.]/g, "");
            } 
             if (inputKey ==='sbp') {
                this.sbp_range.value = this.sbp_range.value.replace(/[^0-9.]/g, "");
            } 
             if (inputKey === 'hdl') {
                this.hdlCholesteron_range.value = this.hdlCholesteron_range.value.replace(/[^0-9.]/g, "");
            } 
             if (inputKey === 'total') {
                this.totalCholesterol_range.value = this.totalCholesterol_range.value.replace(/[^0-9.]/g, "");
            } 
             if (inputKey === 'year') {
                this.age_range.value = this.age_range.value.replace(/[^0-9.]/g, "");
            }
        },
        async handleInput(inputKey) {
            if( inputKey === 'SID_range'){
                this.SID_range = this.SID_range.replace(/[^0-9.]/g, "");
            } 
            if( inputKey === 'uacr'){
                this.uacr_range_front_end = this.uacr_range_front_end.replace(/[^0-9.]/g, "");
            }
           
             if( inputKey === 'hb'){
                this.HbA1C_range = this.HbA1C_range.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'SID_range' && this.SID_range.toString().length < 5){
                this.SIDValidation = true
            }

            if(inputKey === 'SID_range' && this.SID_range.toString().length === 5){
                this.SIDValidation = false
                this.isLoading = true
                //this.SDIAPIValue= 4
                //this.SIDValidation = false
                try {
                    const res = await axios.post(`${this.sdiZipCode.URL}?zipCode=${this.SID_range}`)
                    if (res.data == null) {
                        this.SDIAPIValue = -1;
                        this.SDIMissing = 1;
                    } else if (res.data.SDI_Group == 'missing') {
                        this.SDIMissing = 1;
                        this.SDIAPIValue = -1;
                    } else {
                        this.SDIAPIValue = res.data.SDI_decile;
                        this.SDIMissing = 0;
                    }
                    this.isLoading = false;
                } catch (error) {
                    // Handle errors if necessary
                    console.error('Error during API call:', error);
                    this.isLoading = false;
                }
                
            }
        },
        resetTheValueOnceUserYesOrNo(val) {
            if (val == 'sid' && this.isShowSID === 1) {
                this.SID_range = '';
                this.SIDValidation = false
                //this.emptySIDValidation = false;
            }
            if (val == 'hba1c' && this.isShowHbA1C === 1) {
                this.HbA1C_range = '';
                this.HbA1CValidation = false
                this.emptyHbA1CValidation = false;
            }
            if (val == 'uacr' && this.isShowUACR === 1) {
                this.uacr_range_front_end = "";
                this.uacr_range = "";
                this.uacrValidation = false;
                this.emptyUacrValidation = false;
            }
        },
        latestIconsValidation(val) {
            if (val == 'uacr') {
                this.iconUacrValidation = !this.iconUacrValidation;
            } else if (val === 'HbA1C') {
                this.iconHbA1CValidation = !this.iconHbA1CValidation;
            } else if (val === 'sid') {
                this.iconSIDValidation = !this.iconSIDValidation
            }
        },
        async latestValidation(val, input) {

            if (this.uacr_range && this.uacr_range_front_end < 0 || this.uacr_range_front_end > 25000) {
                this.uacrValidation = true;
            } else {
                this.uacrValidation = false;
            }
            if (val === 'HbA1C' && this.HbA1C_range < 3 || this.HbA1C_range > 15) {
                this.HbA1CValidation = true
            } else {
                this.HbA1CValidation = false
            }
            if (val === 'sid') {
                this.SID_range = input.target.value
            }
            if (val === 'uacr') {

                this.uacr_range_front_end = input.target.value === '0' ? 0 : input.target.value
                this.uacr_range = this.uacr_range_front_end == '0' ? 0.1 : this.uacr_range_front_end
              
            }
            
            if (val === 'uacr' && this.uacr_range === "") {
                this.emptyUacrValidation = true;
                this.uacrValidation = false;
            }
            if (val == 'HbA1C' && this.HbA1C_range === "") {
                this.emptyHbA1CValidation = true;
                this.HbA1CValidation = false
            }
            if (val == 'sid' && this.SID_range === "") {
               // this.emptySIDValidation = true;
                this.SIDValidation = true
            }
            if (val === 'uacr' && this.uacr_range !== "") {
                this.emptyUacrValidation = false;
            }
            if (val == 'HbA1C' && this.HbA1C_range !== "") {
                this.emptyHbA1CValidation = false;
            }
            if (val == 'sid' && this.SID_range !== "") {
                this.SIDValidation = false;

            }
        },
        alertMessage(val) {
            if (val === 'diabetes') {
                this.diabetesIcon = !this.diabetesIcon;
            } else if (val === "currentSmoker") {
                this.currentSmokerIcon = !this.currentSmokerIcon
            } else if (val === "htnMeds") {
                this.htnMedsIcon = !this.htnMedsIcon
            } else {
                this.cholesteronTreatedIcon = !this.cholesteronTreatedIcon
            }
        },
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            this.activeItem = menuItem;
        },
        
        hcmCalculatorFormula() {
            
            const sexValue = this.sex_range;
            const ageValue = this.age_range.value;
            const totalCholesterolValue = this.totalCholesterol_range.value;
            const hdlCholesteronValue = this.hdlCholesteron_range.value;
            const sbpValue = this.sbp_range.value;
            const diabetesValue = this.diabetes_range;
            const currentSmokerValue = this.currentSmoker_range;
            const bmiValue = this.bmi_range.value;
            const egfrValue = this.egfr_range.value;
            const htmlmedsValue = this.htmlmeds_range;
            const htnValue = this.htn_range;
            const cholesteronTreatedValue = this.cholesteronTreated_range;
            const uacrValue = this.uacr_range;
            //30 years variables
            let age = this.age_range.value;
            let tc = this.totalCholesterol_range.value;
            let hdl = this.hdlCholesteron_range.value;
            let sbp = this.sbp_range.value;
            let diabetes = this.diabetes_range;
            let currentSmoker = this.currentSmoker_range;
            let egfr = this.egfr_range.value;
            let hdn = this.htmlmeds_range;
            let statin = this.cholesteronTreated_range;
            let bmi = this.bmi_range.value
            let diabestValidation = diabetesValue === 1 ? 1 : 0;
            let currentSmokerValidation = currentSmokerValue === 1 ? 1 : 0;
            let htmlmedsValueValidation = htmlmedsValue === 1 ? 1 : 0;
            let cholesteronTreatedValidation = cholesteronTreatedValue === 1 ? 1 : 0;
            if (sexValue === 1) {
                let totalValuestchdl = totalCholesterolValue - hdlCholesteronValue;
                let carotSymbol = Math.pow((age - 55) / 10, 2);
                // start Heart failure women
                let disabetsFirstHearFailureWomenValue = diabetesValue === 1 ? 1.038346 : 0;
                let currentSmokerFirstHearFailureWomenValue = currentSmokerValue === 1 ? 0.583916 : 0;
                let htnValueFirstValue = htmlmedsValue === 1 ? 0.3534442 : 0;
                let htnValueSecondValue = htmlmedsValue === 1 ? 0.0981511 * (Math.max(sbpValue, 110) - 130) / 20 : 0;
                let disabetsSecondHearFailureWomenValue = diabetesValue === 1 ? 0.3581041 * (ageValue - 55) / 10 : 0;
                let currentSmokerSecondHearFailureWomenValue = currentSmokerValue === 1 ? 0.1159453 * (ageValue - 55) / 10 : 0;
                let totalHeartFailureWomen =
                    - 4.310409
                    + 0.8998235 * (ageValue - 55) / 10
                    - 0.4559771 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.3576505 * (Math.max(sbpValue, 110) - 130) / 20
                    + disabetsFirstHearFailureWomenValue
                    + currentSmokerFirstHearFailureWomenValue
                    - 0.0072294 * (Math.min(bmiValue, 30) - 25) / 5
                    + 0.2997706 * (Math.max(bmiValue, 30) - 30) / 5
                    + 0.7451638 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.0557087 * (Math.max(egfrValue, 60) - 90) / -15
                    + htnValueFirstValue
                    - htnValueSecondValue
                    - 0.0946663 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - disabetsSecondHearFailureWomenValue
                    - currentSmokerSecondHearFailureWomenValue
                    - 0.003878 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5
                    - 0.1884289 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                // start UACR Heart failure women
                let totalHeartFailureWomenUACR =
                    - 4.841506
                    + 0.9145975 * (ageValue - 55) / 10
                    - 0.4441346 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.3260323 * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.9611365 * diabestValidation
                    + 0.5755787 * currentSmokerValidation
                    + 0.0008831 * (Math.min(bmiValue, 30) - 25) / 5
                    + 0.2988964 * (Math.max(bmiValue, 30) - 30) / 5
                    + 0.5915291 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.0556823 * (Math.max(egfrValue, 60) - 90) / -15
                    + 0.3314097 * htmlmedsValueValidation
                    - 0.1078596 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.0875231 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.356859 * diabestValidation * (ageValue - 55) / 10
                    - 0.1220248 * currentSmokerValidation * (ageValue - 55) / 10
                    - 0.0053637 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5
                    - 0.1610389 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.2197281 * Math.log(this.uacr_range)
                // start HBA1C Heart failure women
                let HBACCtotalHeartFailure10years = diabestValidation === 1 ? 0.1856442 * (this.HbA1C_range - 5.3) : 0.1833083 * (this.HbA1C_range - 5.3)
                let totalHeartFailureWomenHBA1C =
                    - 4.288225
                    + (0.8997391 * ((ageValue - 55) / 10))
                    - (0.4422749 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3378691 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.681284
                    + currentSmokerValidation * 0.5886005
                    - (0.0148657 * (Math.min(bmiValue, 30) - 25) / 5)
                    + (0.2958374 * (Math.max(bmiValue, 30) - 30) / 5)
                    + (0.73447 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.05926 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.3543475
                    - htmlmedsValueValidation * 0.1002139 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.0878765 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.303684 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.1178943 * (ageValue - 55) / 10
                    - (0.008345 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5)
                    - (0.1912183 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + HBACCtotalHeartFailure10years
                // start SDI Heart failure women
                var updateSIDHearFailureValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureValue = 0.1343318
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureValue = 0.2496522
                }
                let SDITenYearsSDIMissing = this.SDIMissing == 1 ? 0.1915023 : 0
                let totalHeartFailureWomenSDI =
                    - 4.409382
                    + (0.8819156 * ((ageValue - 55) / 10))
                    - 0.4495491 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.3457405 * (Math.max(sbpValue, 110) - 130) / 20
                    + 1.02632 * diabestValidation
                    + 0.5371646 * currentSmokerValidation
                    - 0.0168447 * (Math.min(bmiValue, 30) - 25) / 5
                    + 0.2805126 * (Math.max(bmiValue, 30) - 30) / 5
                    + 0.7315223 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.0651679 * (Math.max(egfrValue, 60) - 90) / -15
                    + 0.3491487 * htmlmedsValueValidation
                    - 0.0890335 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.0971028 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.3528078 * diabestValidation * (ageValue - 55) / 10
                    - 0.106216 * currentSmokerValidation * (ageValue - 55) / 10
                    + 0.0064998 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5
                    - 0.1899413 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                    + updateSIDHearFailureValue
                    + SDITenYearsSDIMissing
                // start total Heart failure women
                var updateSIDTotalHearFailureValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalHearFailureValue = 0.1213034
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalHearFailureValue = 0.2314147
                }
                let TenYearsWoemnSDIDecileMissing = this.SDIMissing == 1 ? 0.1819138 : 0
                let TenYearsWomenUACRMissing = this.uacr_range == "" ? 0.0395368 : 0.1948135 * Math.log(this.uacr_range)
                let TenYearsWomenHBA1CMissing = this.HbA1C_range == "" ? 0.0010583 : 0
                let heartFailure10yearsTotal = 0
                if (this.HbA1C_range !== "") {
                    heartFailure10yearsTotal = diabestValidation === 1 ? 0.176668 * (this.HbA1C_range - 5.3) : 0.1614911 * (this.HbA1C_range - 5.3)
                }
                let totalHeartFailureWomenTotal =
                    - 4.896524
                    + (0.884209 * ((ageValue - 55) / 10))
                    - (0.421474 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3002919 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.6170359
                    + currentSmokerValidation * 0.5380269
                    - (0.0191335 * (Math.min(bmiValue, 30) - 25) / 5)
                    + (0.2764302 * (Math.max(bmiValue, 30) - 30) / 5)
                    + (0.5975847 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0654197 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.3313614
                    - htmlmedsValueValidation * 0.1002304 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.0845363 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.2989062 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.1111354 * (ageValue - 55) / 10
                    + (0.0008104 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5)
                    - (0.1666635 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDTotalHearFailureValue
                    // + 0.1948135 * Math.log(this.uacr_range)
                    + heartFailure10yearsTotal
                    + TenYearsWoemnSDIDecileMissing
                    + TenYearsWomenUACRMissing
                    - TenYearsWomenHBA1CMissing
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomen) / (1 + Math.exp(totalHeartFailureWomen)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if (((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenUACR) / (1 + Math.exp(totalHeartFailureWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenHBA1C) / (1 + Math.exp(totalHeartFailureWomenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenSDI) / (1 + Math.exp(totalHeartFailureWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenTotal) / (1 + Math.exp(totalHeartFailureWomenTotal)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //end heart failure 
                //start ASCVD Women section             
                const totalAscvdWomenValueBase =
                    - 3.819975
                    + (0.719883 * ((ageValue - 55) / 10))
                    + (0.1176967 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.151185 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0835358 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3592852 * (Math.max(sbpValue, 110) - 130) / 20)
                    + 0.8348585 * diabestValidation
                    + 0.4831078 * currentSmokerValidation
                    + (0.4864619 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0397779 * (Math.max(egfrValue, 60) - 90) / -15)
                    + 0.2265309 * htmlmedsValueValidation
                    - 0.0592374 * cholesteronTreatedValidation
                    - 0.0395762 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.0844423 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0567839 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0325692 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.1035985 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - 0.2417542 * diabestValidation * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0791142 * (ageValue - 55) / 10
                    - (0.1671492 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                //start UACR ASCVD Women section
                const totalAscvdWomenUACR =
                    - 4.174614
                    + 0.7201999 * ((ageValue - 55) / 10)
                    + 0.1135771 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1493506 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.0726677 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.3436259 * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.7773094 * diabestValidation
                    + 0.4746662 * currentSmokerValidation
                    + 0.3824646 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.0394178 * (Math.max(egfrValue, 60) - 90) / -15
                    + 0.2125182 * htmlmedsValueValidation
                    - 0.0603046 * cholesteronTreatedValidation
                    - 0.0466053 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.0733118 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0534262 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0325689 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.0999887 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.2411762 * diabestValidation * (ageValue - 55) / 10
                    - 0.0826941 * currentSmokerValidation * (ageValue - 55) / 10
                    - 0.1444737 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.1501217 * Math.log(this.uacr_range);
                //start HBA1C ASCVD Women section
                let hba1ASCVD10yearsValue = diabestValidation === 1 ? 0.1339055 * (this.HbA1C_range - 5.3) : 0.1596461 * (this.HbA1C_range - 5.3)
                const totalAscvdWomenHBA1C =
                    - 3.838746
                    + (0.7111831 * ((ageValue - 55) / 10))
                    + (0.106797 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1425745 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0736824 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3480844 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.5112951
                    + currentSmokerValidation * 0.4880292
                    + (0.4754997 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0438132 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.2259093
                    - cholesteronTreatedValidation * 0.0648872
                    - htmlmedsValueValidation * 0.0437645 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.0697082 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0506382 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0327475 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0996442 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.1924338 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0803539 * (ageValue - 55) / 10
                    - (0.1682586 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + hba1ASCVD10yearsValue
                //start SDI ASCVD Women section
                //svdascvd10yearsValue
                var updateSIDTotalASCVDValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalASCVDValue = 0.1473705
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalASCVDValue = 0.2451878
                }
                let svdascvd10yearsValueSDIMissing = this.SDIMissing == 1 && 0.1691593
                const totalAscvdWomenSDI =
                    - 3.955898
                    + (0.7028123 * ((ageValue - 55) / 10))
                    + (0.1056078 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1502263 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0488757 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3402681 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.838022
                    + currentSmokerValidation * 0.4064592
                    + (0.4838394 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0480415 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.2270648
                    - cholesteronTreatedValidation * 0.0585626
                    - htmlmedsValueValidation * 0.0349485 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1017299 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.062389 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0285106 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.1033711 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.2477845 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0544326 * (ageValue - 55) / 10
                    - (0.1735372 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDTotalASCVDValue
                    + svdascvd10yearsValueSDIMissing
                //start total ASCVD Women section
                var updateSIDTotalASCVDValues = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalASCVDValues = 0.1413965
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalASCVDValues = 0.228136
                }
                console.log ("updateSIDTotalASCVDValues", updateSIDTotalASCVDValues)
                let totalDiabietsUACRASCVD = 0
                if (this.HbA1C_range !== '') {
                    totalDiabietsUACRASCVD = diabestValidation === 1 ? 0.123192 * (this.HbA1C_range - 5.3) : 0.1410572 * (this.HbA1C_range - 5.3)
                }
                let TenYearsWoemnASCDSDIDecileMissing = this.SDIMissing == 1 ? 0.1588908 : 0
                let TenYearsWomenASCDUACRMissing = this.uacr_range == "" ? 0.0061613 : 0.1371824 * Math.log(this.uacr_range)
                let TenYearsWomenASCDHBA1CMissing = this.HbA1C_range == "" ? 0.005866 : 0
                const totalAscvdWomenTotal =
                    - 4.291503
                    + 0.7023067 * ((ageValue - 55) / 10)
                    + 0.0898765 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1407316 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.0256648 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.314511 * (Math.max(sbpValue, 110) - 130) / 20
                    + diabestValidation * 0.4799217
                    + currentSmokerValidation * 0.4062049
                    + 0.3847744 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.0495174 * (Math.max(egfrValue, 60) - 90) / -15
                    + htmlmedsValueValidation * 0.2133861
                    - cholesteronTreatedValidation * 0.0678552
                    - htmlmedsValueValidation * 0.0451416 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.0788187 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0535985 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0291762 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.0961839 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - diabestValidation * 0.2001466 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0586472 * (ageValue - 55) / 10
                    - 0.1537791 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                    + updateSIDTotalASCVDValues
                    + totalDiabietsUACRASCVD
                    + TenYearsWoemnASCDSDIDecileMissing
                    + TenYearsWomenASCDUACRMissing
                    + TenYearsWomenASCDHBA1CMissing

                    console.log ("totalAscvdWomenTotal", totalAscvdWomenTotal)
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenValueBase) / (1 + Math.exp(totalAscvdWomenValueBase)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenUACR) / (1 + Math.exp(totalAscvdWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenHBA1C) / (1 + Math.exp(totalAscvdWomenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenSDI) / (1 + Math.exp(totalAscvdWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenTotal) / (1 + Math.exp(totalAscvdWomenTotal)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //end ASCVD Women end section
                //start CVD Women section
                //Base women
                const totalCVDWomenBase =
                    -3.307728
                    + (0.7939329 * (ageValue - 55) / 10)
                    + (0.0305239 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1606857 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2394003 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3600781 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.8667604
                    + currentSmokerValidation * 0.5360739
                    + (0.6045917 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0433769 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.3151672
                    - cholesteronTreatedValidation * 0.1477655
                    + htmlmedsValueValidation * - 0.0663612 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1197879 *
                    (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0819715 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0306769 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0946348 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * - 0.27057 * (ageValue - 55) / 10
                    + currentSmokerValidation * -0.078715 * (ageValue - 55) / 10
                    - (0.1637806 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                //Base CVD UACR women
                const totalCVDWomenUACR =
                    - 3.738341
                    + (0.7969249 * ((ageValue - 55) / 10))
                    + (0.0256635 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1588107 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2255701 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3396649 * (Math.max(sbpValue, 110) - 130) / 20)
                    + 0.8047515 * diabestValidation
                    + 0.5285338 * currentSmokerValidation
                    + (0.4803511 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0434472 * (Math.max(egfrValue, 60) - 90) / -15)
                    + 0.2985207 * htmlmedsValueValidation
                    - 0.1497787 * cholesteronTreatedValidation
                    - 0.0742889 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.106756 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0778126 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0306768 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0907168 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - 0.2705122 * diabestValidation * (ageValue - 55) / 10
                    - 0.0830564 * currentSmokerValidation * (ageValue - 55) / 10
                    - (0.1389249 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + 0.1793037 * Math.log(this.uacr_range)
                //HbA1c 10 years women          
                let hbscValueCVD = diabestValidation == 1 ? 0.1338348 * (this.HbA1C_range - 5.3) : 0.1622409 * (this.HbA1C_range - 5.3)
                const totalCVDWomenHBA1C =
                    - 3.306162
                    + (0.7858178 * ((ageValue - 55) / 10))
                    + (0.0194438 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1521964 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2296681 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3465777 * (Math.max(sbpValue, 110) - 130) / 20)
                    + 0.5366241 * diabestValidation
                    + 0.5411682 * currentSmokerValidation
                    + (0.5931898 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0472458 * (Math.max(egfrValue, 60) - 90) / -15)
                    + 0.3158567 * htmlmedsValueValidation
                    - 0.1535174 * cholesteronTreatedValidation
                    - 0.0687752 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.1054746 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0761119 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0307469 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0905966 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - 0.2241857 * diabestValidation * (ageValue - 55) / 10
                    - 0.080186 * currentSmokerValidation * (ageValue - 55) / 10
                    - (0.1667286 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + hbscValueCVD
                // SID CVD 10 years women
                var updateSIDTotalCVD = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalCVD = 0.1442776
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalCVD = 0.2421409
                }
                let svdCVD10yearsValidationSDIMissing = this.SDIMissing == 1 && 0.1885076;
                const totalCVDWomenSDI =
                    - 3.461564
                    + (0.7754083 * ((ageValue - 55) / 10))
                    + (0.0221756 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1650828 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2180808 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3381188 * (Math.max(sbpValue, 110) - 130) / 20)
                    + 0.8624372 * diabestValidation
                    + 0.4663953 * currentSmokerValidation
                    + (0.5919004 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0516821 * (Math.max(egfrValue, 60) - 90) / -15)
                    + 0.3182166 * htmlmedsValueValidation
                    - 0.1460816 * cholesteronTreatedValidation
                    - 0.0574455 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.1302287 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.083509 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0282181 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0952647 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - 0.2718966 * diabestValidation * (ageValue - 55) / 10
                    - 0.0641738 * currentSmokerValidation * (ageValue - 55) / 10
                    - (0.1717026 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDTotalCVD
                    + svdCVD10yearsValidationSDIMissing

                
                //Total CVD 10 years women
                var updateSIDTotalCVDWomen = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalCVDWomen = 0.1361989
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalCVDWomen = 0.2261596
                }
                let totalWomen10years = 0
                if (this.HbA1C_range !== "") {
                    totalWomen10years = diabestValidation == 1 ? 0.1298513 * (this.HbA1C_range - 5.3) : 0.1412555 * (this.HbA1C_range - 5.3)
                }
                let TenYearsWoemnCVDSDIDecileMissing = this.SDIMissing == 1 || this.SID_range === "" ? 0.1804508 : 0
                let TenYearsWomenCVDUACRMissing = this.uacr_range == "" ? 0.0198413 : 0.1645922 * Math.log(this.uacr_range)
                let TenYearsWomenCVDHBA1CMissing = this.HbA1C_range == "" ? 0.0031658 : 0
                const totalCVDWomenAll =
                    - 3.860385
                    + (0.7716794 * ((ageValue - 55) / 10))
                    + (0.0062109 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1547756 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.1933123 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3071217 * (Math.max(sbpValue, 110) - 130) / 20)
                    + 0.496753 * diabestValidation
                    + 0.466605 * currentSmokerValidation
                    + (0.4780697 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0529077 * (Math.max(egfrValue, 60) - 90) / -15)
                    + 0.3034892 * htmlmedsValueValidation
                    - 0.1556524 * cholesteronTreatedValidation
                    - 0.0667026 * htmlmedsValueValidation * ((Math.max(sbpValue, 110) - 130) / 20)
                    + 0.1061825 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0742271 * ((ageValue - 55) / 10) * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0288245 * ((ageValue - 55) / 10) * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0875188 * ((ageValue - 55) / 10) * (Math.max(sbpValue, 110) - 130) / 20)
                    - 0.2267102 * diabestValidation * ((ageValue - 55) / 10)
                    - 0.0676125 * currentSmokerValidation * ((ageValue - 55) / 10)
                    - (0.1493231 * ((ageValue - 55) / 10) * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDTotalCVDWomen
                    + totalWomen10years
                    + TenYearsWoemnCVDSDIDecileMissing
                    + TenYearsWomenCVDUACRMissing
                    - TenYearsWomenCVDHBA1CMissing

            
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {

                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenBase) / (1 + Math.exp(totalCVDWomenBase)) * 100).toFixed(1);
                    this.ModelName = "base model"
                   
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenUACR) / (1 + Math.exp(totalCVDWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                   
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenHBA1C) / (1 + Math.exp(totalCVDWomenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                  
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenSDI) / (1 + Math.exp(totalCVDWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                  
                } else {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenAll) / (1 + Math.exp(totalCVDWomenAll)) * 100).toFixed(1);
                   
                    this.ModelName = "full model"
                   
                }
                //End CVD Women section
                //30 years womensection
                let firstThirtyHFWomenDiabetes = diabetes === 1 ? 0.8330787 : 0;
                let firstThrityHFWomenCurrentSmoker = currentSmoker === 1 ? 0.3438651 : 0;
                let firstThrityHFWomenHDN = hdn === 1 ? 0.333921 : 0;
                let secondThrityHFWomenHDN = hdn === 1 ? 0.0893177 * (Math.max(sbp, 110) - 130) / 20 : 0;
                let secondThirtyHFNWomenDiabetes = diabetes === 1 ? 0.404855 * (age - 55) / 10 : 0;
                let secondThirtyHFNWomenCurrentSmoker = currentSmoker === 1 ? 0.1982991 * (age - 55) / 10 : 0;
                const totalThirtyYearsHeartFailureWomen =
                    - 2.205379
                    + 0.6254374 * (age - 55) / 10
                    - 0.0983038 * carotSymbol
                    - 0.3919241 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3142295 * (Math.max(sbp, 110) - 130) / 20
                    + firstThirtyHFWomenDiabetes
                    + firstThrityHFWomenCurrentSmoker
                    + 0.0594874 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2525536 * (Math.max(bmi, 30) - 30) / 5
                    + 0.2981642 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0667159 * (Math.max(egfr, 60) - 90) / -15
                    + firstThrityHFWomenHDN
                    - secondThrityHFWomenHDN
                    - 0.0974299 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - secondThirtyHFNWomenDiabetes
                    - secondThirtyHFNWomenCurrentSmoker
                    - 0.0035619 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.1564215 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                ///30 years UACR heart Failure womensection
                const totalThrityWomnHeartFailureUACRValue =
                    - 2.538952
                    + 0.6319513 * ((age - 55) / 10)
                    - 0.1009284 * carotSymbol
                    - 0.3787175 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2863393 * (Math.max(sbp, 110) - 130) / 20
                    + 0.7631221 * diabestValidation
                    + 0.3355843 * currentSmokerValidation
                    + 0.0677084 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2517238 * (Math.max(bmi, 30) - 30) / 5
                    + 0.1940067 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0664006 * (Math.max(egfr, 60) - 90) / -15
                    + 0.3171436 * htmlmedsValueValidation
                    - 0.0970661 * htmlmedsValueValidation * (Math.max(sbp, 110) - 130) / 20
                    - 0.0896239 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.400743 * diabestValidation * (age - 55) / 10
                    - 0.2042041 * currentSmokerValidation * (age - 55) / 10
                    - 0.0054699 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.13602 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + 0.1486028 * Math.log(this.uacr_range)
                let heartFaulureDiabetesValue = diabestValidation === 1 ? 0.1448336 * (this.HbA1C_range - 5.3) : 0.1277838 * (this.HbA1C_range - 5.3)
                const heartFailureThityValuewomenHCBA1C =
                    -2.193553
                    + 0.6210856 * ((age - 55) / 10)
                    - 0.1000972 * carotSymbol
                    - 0.3773697 * (Math.min(sbp, 110) - 110) / 20
                    + 0.295316 * (Math.max(sbp, 110) - 130) / 20
                    + 0.5681692 * diabestValidation
                    + 0.3449139 * currentSmokerValidation
                    + 0.0540094 * (Math.min(bmi, 30) - 25) / 5
                    + 0.249767 * (Math.max(bmi, 30) - 30) / 5
                    + 0.2875781 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0692013 * (Math.max(egfr, 60) - 90) / -15
                    + 0.3334936 * htmlmedsValueValidation
                    - ((0.0922339 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    - 0.0907885 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.3554646 * (age - 55) / 10) * diabestValidation)
                    - ((0.2008846 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0079611 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.156803 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + heartFaulureDiabetesValue
                var updateThirtySIDTotalHeartFailureWomen = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalHeartFailureWomen = 0.0960646
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalHeartFailureWomen = 0.1987543
                }
                let SDIValueISMissingThirtyYear = this.SDIMissing == 1 ? 0.1562214 : 0
                const totalThirtyYearsHeartFailureWomenSDI =
                    - 2.317899
                    + 0.5919097 * ((age - 55) / 10)
                    - 0.1023133 * carotSymbol
                    - 0.3864727 * (Math.min(sbp, 110) - 110) / 20
                    + 0.301876 * (Math.max(sbp, 110) - 130) / 20
                    + 0.8162909 * diabestValidation
                    + 0.3449647 * currentSmokerValidation
                    + 0.0574975 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2367826 * (Math.max(bmi, 30) - 30) / 5
                    + 0.2790347 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0742645 * (Math.max(egfr, 60) - 90) / -15
                    + 0.3352935 * htmlmedsValueValidation
                    - 0.0772532 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation
                    - 0.0995144 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.4000423 * (age - 55) / 10 * diabestValidation
                    - 0.1770335 * (age - 55) / 10 * currentSmokerValidation
                    + 0.0083046 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.149585 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateThirtySIDTotalHeartFailureWomen
                    + SDIValueISMissingThirtyYear
                //total heart Failure value
                var updateThirtySIDTotalHeartFailureWomens = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalHeartFailureWomens = 0.0847634
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalHeartFailureWomens = 0.18397
                }
                let thrityYearsWomensHeartFailureValueMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.1485802 : 0
                let thrityYearsWomensHeartFailureValueMissingUACR = this.uacr_range == "" ? 0.0167008 : 0.1273306 * Math.log(this.uacr_range)
                let thrityYearsWomensHeartFailureValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0138979 : 0
                let finalValueThity = 0
                if (this.HbA1C_range !== '') {
                    finalValueThity = diabestValidation == 1 ? 0.1378342 * (this.HbA1C_range - 5.3) : 0.1138832 * (this.HbA1C_range - 5.3)
                }
                const totalThirtyYearsHeartFailureWomenFull =
                    - 2.642208
                    + 0.5927507 * ((age - 55) / 10)
                    - 0.1028754 * carotSymbol
                    - 0.3593781 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2628556 * (Math.max(sbp, 110) - 130) / 20
                    + 0.5113472 * diabestValidation
                    + 0.347344 * currentSmokerValidation
                    + 0.0564656 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2363857 * (Math.max(bmi, 30) - 30) / 5
                    + 0.1971295 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0735227 * (Math.max(egfr, 60) - 90) / -15
                    + 0.3219386 * htmlmedsValueValidation
                    - 0.0880321 * htmlmedsValueValidation * (Math.max(sbp, 110) - 130) / 20
                    - 0.0863132 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.3425359 * diabestValidation * (age - 55) / 10
                    - 0.181405 * currentSmokerValidation * (age - 55) / 10
                    + 0.0031285 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.1356989 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateThirtySIDTotalHeartFailureWomens
                    //+ 0.1273306  * Math.log(this.uacr_range) 
                    + finalValueThity
                    + thrityYearsWomensHeartFailureValueMissingSDI
                    + thrityYearsWomensHeartFailureValueMissingUACR
                    + thrityYearsWomensHeartFailureValueMissingHBAC1
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThirtyYearsHeartFailureWomen) / (1 + Math.exp(totalThirtyYearsHeartFailureWomen)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThrityWomnHeartFailureUACRValue) / (1 + Math.exp(totalThrityWomnHeartFailureUACRValue)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(heartFailureThityValuewomenHCBA1C) / (1 + Math.exp(heartFailureThityValuewomenHCBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThirtyYearsHeartFailureWomenSDI) / (1 + Math.exp(totalThirtyYearsHeartFailureWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThirtyYearsHeartFailureWomenFull) / (1 + Math.exp(totalThirtyYearsHeartFailureWomenFull)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //30 years end Women heart Failure
                //30 years ASCVD women start here
                let firstThirtyASCVDWomenDiabetes = diabetes === 1 ? 0.6296707 : 0;
                let firstThrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.268292 : 0;
                let firstThrityASCVDWomenHDN = hdn === 1 ? 0.1875292 : 0;
                let firstThrityASCVDWomenStatin = statin === 1 ? 0.0152476 : 0;
                let secondThrityASCVDWomenHDN = hdn === 1 ? 0.0276123 * (Math.max(sbp, 110) - 130) / 20 : 0;
                let secondThrityASCVDDWomenStatin = statin === 1 ? 0.0736147 * (totalValuestchdl * 0.02586 - 3.5) : 0;
                let secondThirtyASCVDNWomenDiabetes = diabetes === 1 ? 0.2727793 * (age - 55) / 10 : 0;
                let secondthrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1530907 * (age - 55) / 10 : 0;
                const totalThirtyAscvdWomenValue =
                    - 1.974074
                    + 0.4669202 * (age - 55) / 10
                    - 0.0893118 * carotSymbol
                    + 0.1256901 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1542255 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0018093 * (Math.min(sbp, 110) - 110) / 20
                    + 0.322949 * (Math.max(sbp, 110) - 130) / 20
                    + firstThirtyASCVDWomenDiabetes
                    + firstThrityASCVDWomenCurrentSmoker
                    + 0.100106 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0499663 * (Math.max(egfr, 60) - 90) / -15
                    + firstThrityASCVDWomenHDN
                    + firstThrityASCVDWomenStatin
                    - secondThrityASCVDWomenHDN
                    + secondThrityASCVDDWomenStatin
                    - 0.0521962 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0316918 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1046101 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - secondThirtyASCVDNWomenDiabetes
                    - secondthrityASCVDWomenCurrentSmoker
                    - 0.1299149 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                //30 years UACR ASCVD women start here
                const totalThirtyAscvdWomenUACR =
                    -2.178888
                    + 0.4629669 * ((age - 55) / 10)
                    - 0.0902777 * carotSymbol
                    + 0.1215214 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1522069 * (hdl * 0.02586 - 1.3) / 0.3
                    + 0.0092679 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3113609 * (Math.max(sbp, 110) - 130) / 20
                    + 0.581256 * diabestValidation
                    + 0.263167 * currentSmokerValidation
                    + 0.0391726 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0492959 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1786178 * htmlmedsValueValidation
                    + 0.0131058 * cholesteronTreatedValidation
                    - 0.0325135 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation
                    + 0.0617093 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation
                    - 0.0489189 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0321079 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1003185 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.2684574 * (age - 55) / 10 * diabestValidation
                    - 0.1547301 * (age - 55) / 10 * currentSmokerValidation
                    - 0.1130703 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0903471 * Math.log(this.uacr_range)
                let totalThirtyASCDHDBc1Value = diabestValidation === 1 ? 0.0875827 * (this.HbA1C_range - 5.3) : 0.1126417 * (this.HbA1C_range - 5.3)
                const totalThirtyAscvdWomenHbA1c =
                    - 2.011533
                    + 0.4555574 * ((age - 55) / 10)
                    - 0.0903501 * carotSymbol
                    + 0.1148321 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1458754 * (hdl * 0.02586 - 1.3) / 0.3
                    + 0.0089323 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3139029 * (Math.max(sbp, 110) - 130) / 20
                    + 0.386281 * diabestValidation
                    + 0.2714309 * currentSmokerValidation
                    + 0.0930987 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0532216 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1862181 * htmlmedsValueValidation
                    + 0.0106964 * cholesteronTreatedValidation
                    - 0.0329713 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation
                    + 0.0583609 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation
                    - 0.0463273 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0324717 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1004777 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.2266944 * (age - 55) / 10 * diabestValidation
                    - 0.1541859 * (age - 55) / 10 * currentSmokerValidation
                    - 0.1286005 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + totalThirtyASCDHDBc1Value
                var updateThirtySIDASCVDWomens = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDASCVDWomens = 0.1149139
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDASCVDWomens = 0.1976537
                }
                let ASCVDThirtyYearValueSDIMissing = this.SDIMissing == 1 ? 0.1391241 : 0
                const totalThirtyAscvdWomenSdi =
                    -2.116951
                    + 0.4396545 * ((age - 55) / 10)
                    - 0.0918489 * carotSymbol
                    + 0.1132729 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1544977 * (hdl * 0.02586 - 1.3) / 0.3
                    + 0.036315 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3049229 * (Math.max(sbp, 110) - 130) / 20
                    + 0.6344794 * diabestValidation
                    + 0.234514 * currentSmokerValidation
                    + 0.0898312 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0564502 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1933487 * htmlmedsValueValidation
                    + 0.0220467 * cholesteronTreatedValidation
                    - 0.0229229 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation
                    + 0.0903326 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation
                    - 0.0579383 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0274011 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1039749 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.2785102 * (age - 55) / 10 * diabestValidation
                    - 0.1167267 * (age - 55) / 10 * currentSmokerValidation
                    - 0.1269382 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateThirtySIDASCVDWomens
                    + ASCVDThirtyYearValueSDIMissing
                var updateThirtySIDTotalASCVDWomens = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalASCVDWomens = 0.1107632
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalASCVDWomens = 0.1840367
                }
                let thrityYearsWomensACVDValueMissingSDI = this.SDIMissing == 1 || this.SID_range === "" ? 0.1308962 : 0
                let thrityYearsWomensACVDValueMissingUACR = this.uacr_range == "" ? - 0.0147785 : 0.0810739 * Math.log(this.uacr_range)
                let thrityYearsWomensACVDValueMissingHBAC1 = this.HbA1C_range == "" ? 0.017301 : 0
                let totalThirtyYearsWomenDiabetesTotal = 0
                if (this.HbA1C_range !== '') {
                    totalThirtyYearsWomenDiabetesTotal = diabestValidation === 1 ? 0.0794709 * (this.HbA1C_range - 5.3) : 0.1002615 * (this.HbA1C_range - 5.3)
                }
                const totalThirtyAscvdWomenFull =
                    -2.314066
                    + 0.4386739 * ((age - 55) / 10)
                    - 0.0921956 * carotSymbol
                    + 0.0977728 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1453525 * (hdl * 0.02586 - 1.3) / 0.3
                    + 0.0590925 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2862862 * (Math.max(sbp, 110) - 130) / 20
                    + 0.3669136 * diabestValidation
                    + 0.2354695 * currentSmokerValidation
                    + 0.0354338 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0573093 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1840085 * htmlmedsValueValidation
                    + 0.0117504 * cholesteronTreatedValidation
                    - 0.0331945 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation
                    + 0.0664311 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation
                    - 0.0492826 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0288888 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0964709 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.2279648 * (age - 55) / 10 * diabestValidation
                    - 0.120405 * (age - 55) / 10 * currentSmokerValidation
                    - 0.1157635 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateThirtySIDTotalASCVDWomens
                    + totalThirtyYearsWomenDiabetesTotal
                    + thrityYearsWomensACVDValueMissingSDI
                    + thrityYearsWomensACVDValueMissingUACR
                    + thrityYearsWomensACVDValueMissingHBAC1
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenValue) / (1 + Math.exp(totalThirtyAscvdWomenValue)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenUACR) / (1 + Math.exp(totalThirtyAscvdWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenHbA1c) / (1 + Math.exp(totalThirtyAscvdWomenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenSdi) / (1 + Math.exp(totalThirtyAscvdWomenSdi)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenFull) / (1 + Math.exp(totalThirtyAscvdWomenFull)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //ASCVD end here
                //30 years CVD women start from here
                let firstThirtyCVDWomenDiabetes = diabetes === 1 ? 0.6793894 : 0;
                let firstThrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.3196112 : 0;
                let firstThrityCVDWomenHDN = hdn === 1 ? 0.2894 : 0;
                let firstThrityCVDWomenStatin = statin === 1 ? 0.075688 : 0;
                let secondThrityCVDWomenHDN = hdn === 1 ? 0.056367 * (Math.max(sbp, 110) - 130) / 20 : 0;
                let secondThrityCVDWomenStatin = statin === 1 ? 0.1071019 * (totalValuestchdl * 0.02586 - 3.5) : 0;
                let secondThirtyCVDNWomenDiabetes = diabetes === 1 ? 0.3206166 * (age - 55) / 10 : 0;
                let secondthrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1607862 * (age - 55) / 10 : 0;
                const thrityYearsCVDWomen =
                    - 1.318827
                    + 0.5503079 * (age - 55) / 10
                    - 0.0928369 * carotSymbol
                    + 0.0409794 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1663306 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1628654 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3299505 * (Math.max(sbp, 110) - 130) / 20
                    + firstThirtyCVDWomenDiabetes
                    + firstThrityCVDWomenCurrentSmoker
                    + 0.1857101 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0553528 * (Math.max(egfr, 60) - 90) / -15
                    + firstThrityCVDWomenHDN
                    - firstThrityCVDWomenStatin
                    - secondThrityCVDWomenHDN
                    + secondThrityCVDWomenStatin
                    - 0.0751438 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0301786 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0998776 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - secondThirtyCVDNWomenDiabetes
                    - secondthrityCVDWomenCurrentSmoker
                    - 0.1450788 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                //30 years UACR CVD women start from here
                const thrityYearsCVDWomenUACR =
                    -1.583738
                    + (0.5491768 * ((age - 55) / 10))
                    - 0.0937311 * carotSymbol
                    + 0.0359847 * ((totalValuestchdl) * 0.02586 - 3.5)
                    - 0.1642965 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1483404 * (Math.min(sbp, 110) - 110) / 20
                    + 0.313353 * (Math.max(sbp, 110) - 130) / 20
                    + 0.6253766 * diabestValidation
                    + 0.3147172 * currentSmokerValidation
                    + 0.1094663 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0550705 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2782433 * htmlmedsValueValidation
                    - 0.0786239 * cholesteronTreatedValidation
                    - ((0.0628947 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + (0.093204 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation
                    - 0.0710685 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0306363 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0951455 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - (0.3168231 * (age - 55) / 10) * diabestValidation
                    - (0.1636391 * (age - 55) / 10) * currentSmokerValidation
                    - 0.1265483 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + 0.1142251 * Math.log(this.uacr_range)
                let thieryYearCVDHBA1CdiabestValidation = diabestValidation === 1 ? 0.0940543 * (this.HbA1C_range - 5.3) : 0.1116486 * (this.HbA1C_range - 5.3)
                const thrityYearsCVDWomenHbA1c =
                    -1.341059
                    + (0.5343493 * ((age - 55) / 10))
                    - 0.0952314 * carotSymbol
                    + 0.0298124 * ((totalValuestchdl) * 0.02586 - 3.5)
                    - 0.1578451 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1504488 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3173368 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4314738 * diabestValidation
                    + 0.3209399 * currentSmokerValidation
                    + 0.1771435 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0582828 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2888947 * htmlmedsValueValidation
                    - 0.0795886 * cholesteronTreatedValidation
                    - ((0.0600438 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + (0.0920598 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation
                    - 0.0696108 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0308807 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0954051 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - (0.2763408 * (age - 55) / 10) * diabestValidation
                    - (0.1623944 * (age - 55) / 10) * currentSmokerValidation
                    - 0.1430514 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thieryYearCVDHBA1CdiabestValidation
                var updateThirtySIDTotalCVDWomens = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalCVDWomens = 0.1129725
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalCVDWomens = 0.1975843
                }
                let ThirytYEarsSDIValueMissing = this.SDIMissing == 1 ? 0.1627381 : 0
                const thrityYearsCVDWomenSDI =
                    -1.493211
                    + (0.5124233 * ((age - 55) / 10))
                    - 0.0978159 * carotSymbol
                    + 0.0322131 * ((totalValuestchdl) * 0.02586 - 3.5)
                    - 0.1717884 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1364536 * (Math.min(sbp, 110) - 110) / 20
                    + 0.3074443 * (Math.max(sbp, 110) - 130) / 20
                    + 0.6709275 * diabestValidation
                    + 0.2897728 * currentSmokerValidation
                    + 0.1670658 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0618439 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2969806 * htmlmedsValueValidation
                    - 0.0665514 * cholesteronTreatedValidation
                    - ((0.0458917 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + (0.1168505 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation
                    - 0.0770419 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.027634 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0992045 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - (0.3208137 * (age - 55) / 10) * diabestValidation
                    - (0.134847 * (age - 55) / 10) * currentSmokerValidation
                    - 0.1399842 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateThirtySIDTotalCVDWomens
                    + ThirytYEarsSDIValueMissing
                var updateThirtySIDTotalCVDWomen = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalCVDWomen = 0.1067741
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalCVDWomen = 0.1853138
                }
                let totalCalCVDWomenthirtyYear = 0
                if (this.HbA1C_range !== '') {
                    totalCalCVDWomenthirtyYear = diabestValidation === 1 ? 0.0925285 * (this.HbA1C_range - 5.3) : 0.0975598 * (this.HbA1C_range - 5.3)
                }
                let thrityYearsWomensCVDValueMissingSDI = this.SDIMissing == 1 || this.SID_range === "" ? 0.1567115 : 0
                let thrityYearsWomensCVDValueMissingUACR = this.uacr_range == "" ? 0.0006181 : 0.1028065 * Math.log(this.uacr_range)
                let thrityYearsWomensCVDValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0101713 : 0
                const thrityYearsCVDWomenFull =
                    -1.748475
                    + (0.5073749 * ((age - 55) / 10))
                    - 0.0981751 * carotSymbol
                    + 0.0162303 * ((totalValuestchdl) * 0.02586 - 3.5)
                    - 0.1617147 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1111241 * (Math.min(sbp, 110) - 110) / 20
                    + 0.282946 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4004069 * diabestValidation
                    + 0.2918701 * currentSmokerValidation
                    + 0.1017102 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0622643 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2872416 * htmlmedsValueValidation
                    - 0.0768135 * cholesteronTreatedValidation
                    - 0.0557282 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation
                    + 0.0917585 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation
                    - 0.0679131 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.029076 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0907755 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - 0.2702118 * (age - 55) / 10 * diabestValidation
                    - 0.1373216 * (age - 55) / 10 * currentSmokerValidation
                    - 0.1255864 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateThirtySIDTotalCVDWomen
                    + totalCalCVDWomenthirtyYear
                    + thrityYearsWomensCVDValueMissingSDI
                    + thrityYearsWomensCVDValueMissingUACR
                    + thrityYearsWomensCVDValueMissingHBAC1
            
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomen) / (1 + Math.exp(thrityYearsCVDWomen)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenUACR) / (1 + Math.exp(thrityYearsCVDWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenHbA1c) / (1 + Math.exp(thrityYearsCVDWomenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenSDI) / (1 + Math.exp(thrityYearsCVDWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenFull) / (1 + Math.exp(thrityYearsCVDWomenFull)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
            } else {
                let totalValuestchdl = totalCholesterolValue - hdlCholesteronValue;
                let carotSymbol = Math.pow((age - 55) / 10, 2);
                //start heart Failure men
                let totalHearFailureMenValue =
                    - 3.946391
                    + (0.8972642 * ((ageValue - 55) / 10))
                    - (0.6811466 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3634461 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.923776
                    + currentSmokerValidation * 0.5023736
                    - (0.0485841 * ((Math.min(bmiValue, 30) - 25) / 5))
                    + (0.3726929 * ((Math.max(bmiValue, 30) - 30) / 5))
                    + (0.6926917 * ((Math.min(egfrValue, 60) - 60) / -15))
                    + (0.0251827 * ((Math.max(egfrValue, 60) - 90) / -15))
                    + htmlmedsValueValidation * 0.2980922
                    - htmlmedsValueValidation * 0.0497731 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.1289201 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20))
                    - diabestValidation * 0.3040924 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.1401688 * (ageValue - 55) / 10
                    + (0.0068126 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5))
                    - (0.1797778 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15))
                //start UACR heart Failure men
                let totalHearFailureMenValueUACR =
                    - 4.556907
                    + (0.9111795 * ((ageValue - 55) / 10))
                    - (0.6693649 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3290082 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.8377655
                    + currentSmokerValidation * 0.4978917
                    - (0.042749 * ((Math.min(bmiValue, 30) - 25) / 5))
                    + (0.3624165 * ((Math.max(bmiValue, 30) - 30) / 5))
                    + (0.5075796 * ((Math.min(egfrValue, 60) - 60) / -15))
                    + (0.0137716 * ((Math.max(egfrValue, 60) - 90) / -15))
                    + htmlmedsValueValidation * 0.2739963
                    - htmlmedsValueValidation * 0.0645712 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.1230039 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20))
                    - diabestValidation * 0.3013297 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.1410318 * (ageValue - 55) / 10
                    + (0.0021531 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5))
                    - (0.1548018 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15))
                    + 0.2306299 * Math.log(this.uacr_range)
                //start HBA1C heart Failure men
                let tenYeraHearFailureHBA1C = diabestValidation === 1 ? 0.1652857 * (this.HbA1C_range - 5.3) : 0.1505859 * (this.HbA1C_range - 5.3)
                let totalHearFailureMenValueHBA1C =
                    -  3.961954
                    + (0.911787 * ((ageValue - 55) / 10))
                    - (0.6568071 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3524645 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.5849752
                    + currentSmokerValidation * 0.5014014
                    - (0.0512352 * ((Math.min(bmiValue, 30) - 25) / 5))
                    + (0.365294 * ((Math.max(bmiValue, 30) - 30) / 5))
                    + (0.6892219 * ((Math.min(egfrValue, 60) - 60) / -15))
                    + (0.0292377 * ((Math.max(egfrValue, 60) - 90) / -15))
                    + htmlmedsValueValidation * 0.3038296
                    - htmlmedsValueValidation * 0.0515032 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.1262343 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20))
                    - diabestValidation * 0.2449514 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.1392217 * (ageValue - 55) / 10
                    + (0.0009592 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5))
                    - (0.1917105 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15))
                    + tenYeraHearFailureHBA1C
                //start SDI heart Failure men
                var updateSIDHearFailureTenValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureTenValue = 0.1235632
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureTenValue = 0.3592212
                }
                let HeartFailureSDIValueMissing = this.SDIMissing == 1 ? 0.17924 : 0
                let totalHearFailureMenValueSDI =
                    - 4.058977
                    + (0.894179 * ((ageValue - 55) / 10))
                    - (0.7067398 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.350241 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.9252453
                    + currentSmokerValidation * 0.4364765
                    - (0.0866297 * ((Math.min(bmiValue, 30) - 25) / 5))
                    + (0.3706765 * ((Math.max(bmiValue, 30) - 30) / 5))
                    + (0.6696768 * ((Math.min(egfrValue, 60) - 60) / -15))
                    + (0.0237374 * ((Math.max(egfrValue, 60) - 90) / -15))
                    + htmlmedsValueValidation * 0.2688352
                    - htmlmedsValueValidation * 0.0434892 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.1297155 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20))
                    - diabestValidation * 0.299086 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.1079522 * (ageValue - 55) / 10
                    + (0.0130483 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5))
                    - (0.1797791 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15))
                    + updateSIDHearFailureTenValue
                    + HeartFailureSDIValueMissing
                //start Total heart Failure men
                var updateSIDHearFailureTenTotalValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureTenTotalValue = 0.1106372
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureTenTotalValue = 0.3371204
                }
                let updateDiabeitesHeartFailureTenTotalValue = 0
                if (this.HbA1C_range !== '') {
                    updateDiabeitesHeartFailureTenTotalValue = diabestValidation == 1 ? 0.148297 * (this.HbA1C_range - 5.3) : 0.1234088 * (this.HbA1C_range - 5.3)
                }
                let TwentyYearsWoemnHeartFailureSDIDecileMissing = this.SDIMissing == 1 || this.SID_range == "" ? 0.1694628 : 0
                let TwentyYearsWomenHeartFailureUACRMissing = this.uacr_range == "" ? 0.1702805 : 0.2164607 * Math.log(this.uacr_range)
                let TwentyYearsWomenHeartFailureHBA1CMissing = this.HbA1C_range == "" ? 0.0234637 : 0
                let totalHearFailureMenValueTotal =
                    - 4.663513
                    + (0.9095703 * ((ageValue - 55) / 10))
                    - (0.6765184 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3111651 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.5535052
                    + currentSmokerValidation * 0.4326811
                    - (0.0854286 * ((Math.min(bmiValue, 30) - 25) / 5))
                    + (0.3551736 * ((Math.max(bmiValue, 30) - 30) / 5))
                    + (0.5102245 * ((Math.min(egfrValue, 60) - 60) / -15))
                    + (0.015472 * ((Math.max(egfrValue, 60) - 90) / -15))
                    + htmlmedsValueValidation * 0.2570964
                    - htmlmedsValueValidation * 0.0591177 * (Math.max(sbpValue, 110) - 130) / 20
                    - (0.1219056 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20))
                    - diabestValidation * 0.2437577 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.105363 * (ageValue - 55) / 10
                    + (0.0037907 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5))
                    - (0.1660207 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15))
                    + updateSIDHearFailureTenTotalValue
                    //+ 0.2164607  * Math.log(this.uacr_range)
                    + updateDiabeitesHeartFailureTenTotalValue
                    + TwentyYearsWoemnHeartFailureSDIDecileMissing
                    + TwentyYearsWomenHeartFailureUACRMissing
                    - TwentyYearsWomenHeartFailureHBA1CMissing
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValue) / (1 + Math.exp(totalHearFailureMenValue)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueUACR) / (1 + Math.exp(totalHearFailureMenValueUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueHBA1C) / (1 + Math.exp(totalHearFailureMenValueHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueSDI) / (1 + Math.exp(totalHearFailureMenValueSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueTotal) / (1 + Math.exp(totalHearFailureMenValueTotal)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //End heart Failure men
                //start ASCVD Men section
                const totalAscvdMenValueBase =
                    -3.500655
                    + (0.7099847 * (ageValue - 55) / 10)
                    + (0.1658663 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1144285 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2837212 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3239977 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.7189597
                    + currentSmokerValidation * 0.3956973
                    + (0.3690075 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0203619 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.2036522
                    - cholesteronTreatedValidation * 0.0865581
                    - htmlmedsValueValidation * 0.0322916 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.114563 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0300005 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0232747 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0927024 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.2018525 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0970527 * (ageValue - 55) / 10
                    - (0.1217081 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                //start UACR ASCVD Men section
                const totalAscvdMenValueUACR =
                    - 3.85146
                    + (0.7141718 * (ageValue - 55) / 10)
                    + (0.1602194 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1139086 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2719456 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3058719 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.6600631
                    + currentSmokerValidation * 0.3884022
                    + (0.2466316 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0151852 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.186167
                    - cholesteronTreatedValidation * 0.0894395
                    - htmlmedsValueValidation * 0.0411884 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1058212 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.028089 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0240427 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0912325 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.2004894 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.096936 * (ageValue - 55) / 10
                    - (0.1022867 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + 0.1510073 * Math.log(this.uacr_range)
                //start HBA1C ASCVD Men section
                let hba1cTenYearsASCVD = diabetesValue === 1 ? 0.1157161 * (this.HbA1C_range - 5.3) : 0.1288303 * (this.HbA1C_range - 5.3);
                const totalAscvdMenValueHBA1C =
                    - 3.51835
                    + (0.7064146 * (ageValue - 55) / 10)
                    + (0.1532267 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1082166 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.2675288 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3173809 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.432604
                    + currentSmokerValidation * 0.3958842
                    + (0.3665014 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0250243 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.2061158
                    - cholesteronTreatedValidation * 0.0899988
                    - htmlmedsValueValidation * 0.0334959 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1034168 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0255406 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0247538 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0917441 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.1499195 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.098089 * (ageValue - 55) / 10
                    - (0.1305231 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + hba1cTenYearsASCVD
                //start SDI ASCVD Men section
                var updateSIDASCVDTenTotalValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDASCVDTenTotalValue = 0.0728242
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDASCVDTenTotalValue = 0.2824453
                }
                let ASCVDTenYearsSDIMissing = this.SDIMissing == 1 ? 0.1437348 : 0
                const totalAscvdMenValueSDI =
                    - 3.624712
                    + (0.7150087 * (ageValue - 55) / 10)
                    + (0.1627339 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1194988 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.363659 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3179476 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.7156422
                    + currentSmokerValidation * 0.3404477
                    + (0.3545754 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0157875 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.1786233
                    - cholesteronTreatedValidation * 0.1018269
                    - htmlmedsValueValidation * 0.028313 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1209467 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0285806 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0247348 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0919494 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.1981491 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0776891 * (ageValue - 55) / 10
                    - (0.1284899 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDASCVDTenTotalValue
                    + ASCVDTenYearsSDIMissing
                //start Total ASCVD Men section
                var updateSIDASCVDTenTotalValues = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDASCVDTenTotalValues = 0.0651121
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDASCVDTenTotalValues = 0.2676683
                }
                var totalASCVDDiabetes = 0
                if (this.HbA1C_range !== "") {
                    totalASCVDDiabetes = diabestValidation == 1 ? 0.101282 * (this.HbA1C_range - 5.3) : 0.1092726 * (this.HbA1C_range - 5.3)
                }
                let TwentyYearsWoemnASCVDSDIDecileMissing = this.SDIMissing == 1 || this.SID_range == "" ? 0.1388492 : 0
                let TwentyYearsWomenASCVDUACRMissing = this.uacr_range == "" ? 0.0652944 : 0.1375837 * Math.log(this.uacr_range)
                let TwentyYearsWomenASCVDHBA1CMissing = this.HbA1C_range == "" ? 0.0112852 : 0
                const totalAscvdMenValueTotal =
                    - 3.969788
                    + (0.7128741 * (ageValue - 55) / 10)
                    + (0.1465201 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.1125794 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.3387216 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.2980252 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.399583
                    + currentSmokerValidation * 0.3379111
                    + (0.2582604 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0147769 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.1686621
                    - cholesteronTreatedValidation * 0.1073619
                    - htmlmedsValueValidation * 0.0381038 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1034169 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0228755 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0267453 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.0897449 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.1497464 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.077206 * (ageValue - 55) / 10
                    - (0.1198368 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDASCVDTenTotalValues
                    + totalASCVDDiabetes
                    + TwentyYearsWoemnASCVDSDIDecileMissing
                    + TwentyYearsWomenASCVDUACRMissing
                    - TwentyYearsWomenASCVDHBA1CMissing
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueBase) / (1 + Math.exp(totalAscvdMenValueBase)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueUACR) / (1 + Math.exp(totalAscvdMenValueUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueHBA1C) / (1 + Math.exp(totalAscvdMenValueHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueSDI) / (1 + Math.exp(totalAscvdMenValueSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueTotal) / (1 + Math.exp(totalAscvdMenValueTotal)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //end ASCVD Men section
                //start CVD Men section
                const totalCVDMenBase =
                    - 3.031168
                    + (0.7688528 * (ageValue - 55) / 10)
                    + (0.0736174 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.0954431 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.4347345 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3362658 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.7692857
                    + currentSmokerValidation * 0.4386871
                    + (0.5378979 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0164827 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.288879
                    - cholesteronTreatedValidation * 0.1337349
                    - htmlmedsValueValidation * 0.0475924 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.150273 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0517874 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0191169 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.1049477 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.2251948 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0895067 * (ageValue - 55) / 10
                    - (0.1543702 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15);
                //start UACR CVD Men section
                const totalCVDMenUACR =
                    - 3.510705
                    + 0.7768655 * ((ageValue - 55) / 10)
                    + 0.0659949 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0951111 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.420667 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.3120151 * (Math.max(sbpValue, 110) - 130) / 20
                    + diabestValidation * 0.698521
                    + currentSmokerValidation * 0.4314669
                    + 0.3841364 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.009384 * (Math.max(egfrValue, 60) - 90) / -15
                    + 0.2676494 * htmlmedsValueValidation
                    - 0.1390966 * cholesteronTreatedValidation
                    - 0.0579315 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.1383719 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0488332 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0200406 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.102454 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.2236355 * diabestValidation * (ageValue - 55) / 10
                    - 0.089485 * currentSmokerValidation * (ageValue - 55) / 10
                    - 0.1321848 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.1887974 * Math.log(this.uacr_range)
                //10 year total CVD HBA1C
                let diabetesValueCVD10yearsHBA1C = diabestValidation === 1 ? 0.13159 * (this.HbA1C_range - 5.3) : 0.1295185 * (this.HbA1C_range - 5.3)
                const totalCVDMenHBA1C =
                    - 3.040901
                    + (0.7699177 * ((ageValue - 55) / 10))
                    + (0.0605093 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.0888525 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.417713 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3288657 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.4759471
                    + currentSmokerValidation * 0.4385663
                    + (0.5334616 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0206431 * (Math.max(egfrValue, 60) - 90) / -15)
                    + 0.2917524 * htmlmedsValueValidation
                    - 0.1383313 * cholesteronTreatedValidation
                    - 0.0482622 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.1393796 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0463501 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0205926 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.1037717 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - 0.1737697 * diabestValidation * (ageValue - 55) / 10
                    - 0.0915839 * currentSmokerValidation * (ageValue - 55) / 10
                    - (0.1637039 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + diabetesValueCVD10yearsHBA1C
                //10 year total CVD SDI
                var updateSIDCVDTenTotalValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDCVDTenTotalValue = 0.0889119
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDCVDTenTotalValue = 0.291897
                }
                let menCVDSDITenYearsMissing = this.SDIMissing == 1 ? 0.1508151 : 0
                const totalCVDMenSDI =
                    - 3.159572
                    + (0.7756377 * ((ageValue - 55) / 10))
                    + (0.0715325 * (totalValuestchdl * 0.02586 - 3.5))
                    - (0.0976775 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.5186614 * (Math.min(sbpValue, 110) - 110) / 20)
                    + (0.3235653 * (Math.max(sbpValue, 110) - 130) / 20)
                    + diabestValidation * 0.7722496
                    + currentSmokerValidation * 0.3761129
                    + (0.5180893 * (Math.min(egfrValue, 60) - 60) / -15)
                    + (0.0118451 * (Math.max(egfrValue, 60) - 90) / -15)
                    + htmlmedsValueValidation * 0.2634094
                    - cholesteronTreatedValidation * 0.1455263
                    - htmlmedsValueValidation * 0.0367013 * (Math.max(sbpValue, 110) - 130) / 20
                    + cholesteronTreatedValidation * 0.1617785 * (totalValuestchdl * 0.02586 - 3.5)
                    - (0.0507669 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5))
                    + (0.0178356 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3)
                    - (0.1059337 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20)
                    - diabestValidation * 0.2236755 * (ageValue - 55) / 10
                    - currentSmokerValidation * 0.0723216 * (ageValue - 55) / 10
                    - (0.1548205 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15)
                    + updateSIDCVDTenTotalValue
                    + menCVDSDITenYearsMissing
                //10 year total CVD total
                var tenYearSDIFullvalue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    tenYearSDIFullvalue = 0.0802431
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    tenYearSDIFullvalue = 0.275073
                }
                var tenYearCVDFulldiabestValidation = 0
                if (this.HbA1C_range !== '') {
                    tenYearCVDFulldiabestValidation = diabestValidation == 1 ? 0.1165698 * (this.HbA1C_range - 5.3) : 0.1048297 * (this.HbA1C_range - 5.3)
                }
                let TwentyYearsWoemnCVDSDIDecileMissing = this.SDIMissing == 1 || this.SID_range === "" ? 0.144759 : 0
                let TwentyYearsWomenCVDUACRMissing = this.uacr_range == "" ? 0.1095674 : 0.1772853 * Math.log(this.uacr_range)
                let TwentyYearsWomenCVDHBA1CMissing = this.HbA1C_range == "" ? 0.0230072 : 0
                let totalCVDMenTotal =
                    - 3.631387
                    + 0.7847578 * ((ageValue - 55) / 10)
                    + 0.0534485 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0911282 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.4921973 * (Math.min(sbpValue, 110) - 110) / 20
                    + 0.2972415 * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.4527054 * diabestValidation
                    + 0.3726641 * currentSmokerValidation
                    + 0.3886854 * (Math.min(egfrValue, 60) - 60) / -15
                    + 0.0081661 * (Math.max(egfrValue, 60) - 90) / -15
                    + 0.2508052 * htmlmedsValueValidation
                    - 0.1538484 * cholesteronTreatedValidation
                    - 0.0474695 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20
                    + 0.1415382 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0436455 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0199549 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3
                    - 0.1022686 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20
                    - 0.1762507 * diabestValidation * (ageValue - 55) / 10
                    - 0.0715873 * currentSmokerValidation * (ageValue - 55) / 10
                    - 0.1428668 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15
                    + tenYearSDIFullvalue
                    + tenYearCVDFulldiabestValidation
                    + TwentyYearsWoemnCVDSDIDecileMissing
                    + TwentyYearsWomenCVDUACRMissing
                    - TwentyYearsWomenCVDHBA1CMissing
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenBase) / (1 + Math.exp(totalCVDMenBase)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenUACR) / (1 + Math.exp(totalCVDMenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenHBA1C) / (1 + Math.exp(totalCVDMenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenSDI) / (1 + Math.exp(totalCVDMenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenTotal) / (1 + Math.exp(totalCVDMenTotal)) * 100).toFixed(1);
                 
                    this.ModelName = "full model"
                }
                //end CVD Men section
                //30 years start from here
                let firstThirtyHFWomenDiabetes = diabetesValue === 1 ? 0.6840338 : 0;
                let firstThrityHFWomenCurrentSmoker = currentSmoker === 1 ? 0.2656273 : 0;
                let firstThrityHFWomenHDN = hdn === 1 ? 0.2583631 : 0;
                let secondThrityHFWomenHDN = hdn === 1 ? 0.0391938 * (Math.max(sbp, 110) - 130) / 20 : 0;
                let secondThirtyHFNWomenDiabetes = diabetesValue === 1 ? 0.3273572 * (age - 55) / 10 : 0;
                let secondThirtyHFNWomenCurrentSmoker = currentSmoker === 1 ? 0.2043019 * (age - 55) / 10 : 0;
                const totalThirtyHearFailureMenValue =
                    - 1.95751
                    + 0.5681541 * (age - 55) / 10
                    - 0.1048388 * carotSymbol
                    - 0.4761564 * (Math.min(sbp, 110) - 110) / 20
                    + 0.30324 * (Math.max(sbp, 110) - 130) / 20
                    + firstThirtyHFWomenDiabetes
                    + firstThrityHFWomenCurrentSmoker
                    + 0.0833107 * (Math.min(bmi, 30) - 25) / 5
                    + 0.26999 * (Math.max(bmi, 30) - 30) / 5
                    + 0.2541805 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0638923 * (Math.max(egfr, 60) - 90) / -15
                    + firstThrityHFWomenHDN
                    - secondThrityHFWomenHDN
                    - 0.1269124 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - secondThirtyHFNWomenDiabetes
                    - secondThirtyHFNWomenCurrentSmoker
                    - 0.0182831 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.1342618 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                //Thirty years UACR heart failure men
                const totalThirtyHearFailureMenUACR =
                    - 2.314872
                    + 0.5750236 * (age - 55) / 10
                    - 0.1062268 * carotSymbol
                    - 0.4633994 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2742874 * (Math.max(sbp, 110) - 130) / 20
                    + 0.612208 * diabestValidation
                    + 0.2614987 * currentSmokerValidation
                    + 0.0895459 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2632424 * (Math.max(bmi, 30) - 30) / 5
                    + 0.1430472 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0535184 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2417468 * htmlmedsValueValidation
                    - ((0.0498574 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    - 0.1193827 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.316651 * (age - 55) / 10) * diabestValidation)
                    - ((0.2046122 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0216878 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.1165637 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + 0.1366452 * Math.log(this.uacr_range)
                //30 years HBA1C heart Failure
                let herartFailurethirtyYearDiabeites = diabestValidation == 1 ? 0.1101184 * (this.HbA1C_range - 5.3) : 0.0949198 * (this.HbA1C_range - 5.3)
                const totalThirtyHearFailureMenHbA1c =
                    - 1.974999
                    + 0.5703729 * (age - 55) / 10
                    - 0.1084544 * carotSymbol
                    - 0.4471767 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2910152 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4507242 * diabestValidation
                    + 0.259585 * currentSmokerValidation
                    + 0.0850676 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2637222 * (Math.max(bmi, 30) - 30) / 5
                    + 0.2454706 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0675649 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2611991 * htmlmedsValueValidation
                    - ((0.0408908 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    - 0.1241051 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2849461 * (age - 55) / 10) * diabestValidation)
                    - ((0.2032308 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0239714 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.138301 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + herartFailurethirtyYearDiabeites
                //30 years thirty heart failure SDI
                var thrityYearsHeartFailureSDIMen = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thrityYearsHeartFailureSDIMen = 0.0680528
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thrityYearsHeartFailureSDIMen = 0.2619865
                }
                let ThrityYearHeartFailureSDIMissing = this.SDIMissing == 1 ? 0.1151424 : 0
                const totalThirtyHearFailureMenSDI =
                    -2.060187
                    + 0.5387527 * (age - 55) / 10
                    - 0.1090333 * carotSymbol
                    - 0.4829094 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2843569 * (Math.max(sbp, 110) - 130) / 20
                    + 0.6827667 * diabestValidation
                    + 0.2406677 * currentSmokerValidation
                    + 0.0618028 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2705615 * (Math.max(bmi, 30) - 30) / 5
                    + 0.2255837 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0653632 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2263243 * htmlmedsValueValidation
                    - ((0.0316851 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    - 0.1258716 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.3243709 * (age - 55) / 10) * diabestValidation)
                    - ((0.1596172 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0103092 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.1204785 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thrityYearsHeartFailureSDIMen
                    + ThrityYearHeartFailureSDIMissing
                //Heart filure full
                var thrityYearsHeartFailureFullSDIMen = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thrityYearsHeartFailureFullSDIMen = 0.057746
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thrityYearsHeartFailureFullSDIMen = 0.2446441
                }
                var diabetesThirtyYerasHeartFailureFull = 0
                if (this.HbA1C_range !== '') {
                    diabetesThirtyYerasHeartFailureFull = diabestValidation == 1 ? 0.0985062 * (this.HbA1C_range - 5.3) : 0.0804844 * (this.HbA1C_range - 5.3)
                }
                let thrityYearsmensHeartFailureValuesMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.1076782 : 0
                let thrityYearsmensHeartFailureValuesMissingUACR = this.uacr_range == "" ? 0.1274796 : 0.1233486 * Math.log(this.uacr_range)
                let thrityYearsmensHeartFailureValuesMissingHBAC1 = this.HbA1C_range == "" ? 0.0022806 : 0
                const totalThirtyHearFailureMenFull =
                    - 2.425439
                    + 0.5478829 * (age - 55) / 10
                    - 0.1111928 * carotSymbol
                    - 0.4547346 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2527602 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4385384 * diabestValidation
                    + 0.2397952 * currentSmokerValidation
                    + 0.0640931 * (Math.min(bmi, 30) - 25) / 5
                    + 0.2643081 * (Math.max(bmi, 30) - 30) / 5
                    + 0.1354588 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0570689 * (Math.max(egfr, 60) - 90) / -15
                    + 0.220666 * htmlmedsValueValidation
                    - ((0.0436769 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    - 0.1168376 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2730055 * (age - 55) / 10) * diabestValidation)
                    - ((0.1573691 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0174998 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5
                    - 0.1128676 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thrityYearsHeartFailureFullSDIMen
                    //+ 0.1233486 * Math.log(this.uacr_range) 
                    + diabetesThirtyYerasHeartFailureFull
                    + thrityYearsmensHeartFailureValuesMissingSDI
                    + thrityYearsmensHeartFailureValuesMissingUACR
                    + thrityYearsmensHeartFailureValuesMissingHBAC1
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenValue) / (1 + Math.exp(totalThirtyHearFailureMenValue)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenUACR) / (1 + Math.exp(totalThirtyHearFailureMenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenHbA1c) / (1 + Math.exp(totalThirtyHearFailureMenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenSDI) / (1 + Math.exp(totalThirtyHearFailureMenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenFull) / (1 + Math.exp(totalThirtyHearFailureMenFull)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //30 years end men heart failure
                //30 years ASCVD men start here
                let firstThirtyASCVDWomenDiabetes = diabetes === 1 ? 0.4790257 : 0;
                let firstThrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1782635 : 0;
                let firstThrityASCVDWomenHDN = hdn === 1 ? 0.1421182 : 0;
                let firstThrityASCVDWomenStatin = statin === 1 ? 0.0135996 : 0;
                let secondThrityASCVDWomenHDN = hdn === 1 ? 0.0218265 * (Math.max(sbp, 110) - 130) / 20 : 0;
                let secondThrityASCVDDWomenStatin = statin === 1 ? 0.1013148 * (totalValuestchdl * 0.02586 - 3.5) : 0;
                let secondThirtyASCVDNWomenDiabetes = diabetes === 1 ? 0.2159947 * (age - 55) / 10 : 0;
                let secondthrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1548811 * (age - 55) / 10 : 0;
                const totalThirtyAscvdMenValue =
                    - 1.736444
                    + 0.3994099 * (age - 55) / 10
                    - 0.0937484 * carotSymbol
                    + 0.1744643 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.120203 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0665117 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2753037 * (Math.max(sbp, 110) - 130) / 20
                    + firstThirtyASCVDWomenDiabetes
                    + firstThrityASCVDWomenCurrentSmoker
                    - 0.0218789 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0602553 * (Math.max(egfr, 60) - 90) / -15
                    + firstThrityASCVDWomenHDN
                    + firstThrityASCVDWomenStatin
                    - secondThrityASCVDWomenHDN
                    + secondThrityASCVDDWomenStatin
                    - 0.0312619 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.020673 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0920935 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - secondThirtyASCVDNWomenDiabetes
                    - secondthrityASCVDWomenCurrentSmoker
                    - 0.0712547 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                //total thrity year UACR
                const totalThirtyYearAscvdMenUACR =
                    - 1.873449
                    + 0.3995607 * (age - 55) / 10
                    - 0.094557 * carotSymbol
                    + 0.1686692 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1202145 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0555561 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2633566 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4362036 * diabestValidation
                    + 0.1716233 * currentSmokerValidation
                    - 0.0775282 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0561236 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1319331 * htmlmedsValueValidation
                    + 0.0102428 * cholesteronTreatedValidation
                    - ((0.0269294 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.0920557 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0297021 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0217935 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0893347 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2081467 * (age - 55) / 10) * diabestValidation)
                    - ((0.1542716 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0597254 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0684872 * Math.log(this.uacr_range)
                //ACVD thriy year hba1c
                let thirtyHBACDDiabetes = diabestValidation == 1 ? 0.0591089 * (this.HbA1C_range - 5.3) : 0.0821158 * (this.HbA1C_range - 5.3)
                const totalThirtyYearAscvdMenHbA1c =
                    -1.777708
                    + 0.3883267 * (age - 55) / 10
                    - 0.0958114 * carotSymbol
                    + 0.1613374 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1144418 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0474338 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2691281 * (Math.max(sbp, 110) - 130) / 20
                    + 0.2859773 * diabestValidation
                    + 0.1759553 * currentSmokerValidation
                    - 0.0242898 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0644523 * (Math.max(egfr, 60) - 90) / -15
                    + 0.142874 * htmlmedsValueValidation
                    + 0.0115062 * cholesteronTreatedValidation
                    - ((0.02333 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.0899664 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0275478 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.022573 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.090802 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.1771894 * (age - 55) / 10) * diabestValidation)
                    - ((0.1548847 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0732754 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thirtyHBACDDiabetes
                //Thirty year men SDI
                var thirtyYearMenASCVDSDI = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thirtyYearMenASCVDSDI = 0.0199201
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thirtyYearMenASCVDSDI = 0.194949
                }
                let thirtyYearASCVDMenSDIMissing = this.SDIMissing == 1 ? 0.0863835 : 0
                const totalThirtyYearAscvdMenSDI =
                    - 1.836632
                    + 0.3749788 * (age - 55) / 10
                    - 0.0990063 * carotSymbol
                    + 0.1708505 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1272841 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1275555 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2659339 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4676531 * diabestValidation
                    + 0.1610104 * currentSmokerValidation
                    - 0.0465144 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0596996 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1147096 * htmlmedsValueValidation
                    + 0.0052906 * cholesteronTreatedValidation
                    - ((0.0186687 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.1063151 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0307797 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0218126 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0898242 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.210054 * (age - 55) / 10) * diabestValidation)
                    - ((0.1246327 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0629358 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thirtyYearMenASCVDSDI
                    + thirtyYearASCVDMenSDIMissing
                //thity year ASCVD men full
                var updateSIDHearFailureTenTotalValueFull = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureTenTotalValueFull = 0.015675
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureTenTotalValueFull = 0.1864231
                }
                var diabestValidationFullASCVD = 0
                if (this.HbA1C_range !== "") {
                    diabestValidationFullASCVD = diabestValidation == 1 ? 0.0501422 * (this.HbA1C_range - 5.3) : 0.0722905 * (this.HbA1C_range - 5.3)
                }
                let thrityYearsMensASCVDValueMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.0845697 : 0
                let thrityYearsMensASCVDValueMissingUACR = this.uacr_range == "" ? 0.0252244 : 0.0560171 * Math.log(this.uacr_range)
                let thrityYearsMensASCVDValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0114945 : 0
                const totalThirtyYearAscvdMenFull =
                    - 1.985368
                    + 0.3743566 * (age - 55) / 10
                    - 0.0995499 * carotSymbol
                    + 0.1544808 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1215297 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1083968 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2555179 * (Math.max(sbp, 110) - 130) / 20
                    + 0.2696998 * diabestValidation
                    + 0.1628432 * currentSmokerValidation
                    - 0.077507 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0583407 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1120322 * htmlmedsValueValidation
                    - 0.0025063 * cholesteronTreatedValidation
                    - ((0.0256116 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.0886745 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0254507 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0244639 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.0869146 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.165745 * (age - 55) / 10) * diabestValidation)
                    - ((0.1244714 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0624552 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + updateSIDHearFailureTenTotalValueFull
                    //+ 0.0560171 *  Math.log(this.uacr_range) 
                    + diabestValidationFullASCVD
                    + thrityYearsMensASCVDValueMissingSDI
                    + thrityYearsMensASCVDValueMissingUACR
                    + thrityYearsMensASCVDValueMissingHBAC1
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyAscvdMenValue) / (1 + Math.exp(totalThirtyAscvdMenValue)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenUACR) / (1 + Math.exp(totalThirtyYearAscvdMenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenHbA1c) / (1 + Math.exp(totalThirtyYearAscvdMenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenSDI) / (1 + Math.exp(totalThirtyYearAscvdMenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenFull) / (1 + Math.exp(totalThirtyYearAscvdMenFull)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
                //30 years ASCVD stop here
                //30 years CVD Mens start here
                let firstThirtyCVDWomenDiabetes = diabetes === 1 ? 0.5331276 : 0;
                let firstThrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.2141914 : 0;
                let firstThrityCVDWomenHDN = hdn === 1 ? 0.232714 : 0;
                let firstThrityCVDWomenStatin = statin === 1 ? 0.0272112 : 0;
                let secondThrityCVDWomenHDN = hdn === 1 ? 0.0384488 * (Math.max(sbp, 110) - 130) / 20 : 0;
                let secondThrityCVDWomenStatin = statin === 1 ? 0.134192 * (totalValuestchdl * 0.02586 - 3.5) : 0;
                let secondThirtyCVDNWomenDiabetes = diabetes === 1 ? 0.2585943 * (age - 55) / 10 : 0;
                let secondthrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1566406 * (age - 55) / 10 : 0;
                const thrityYearsCVDMen =
                    - 1.148204
                    + 0.4627309 * (age - 55) / 10
                    - 0.0984281 * carotSymbol
                    + 0.0836088 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1029824 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.2140352 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2904325 * (Math.max(sbp, 110) - 130) / 20
                    + firstThirtyCVDWomenDiabetes
                    + firstThrityCVDWomenCurrentSmoker
                    + 0.1155556 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0603775 * (Math.max(egfr, 60) - 90) / -15
                    + firstThrityCVDWomenHDN
                    - firstThrityCVDWomenStatin
                    - secondThrityCVDWomenHDN
                    + secondThrityCVDWomenStatin
                    - 0.0511759 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0165865 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1101437 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - secondThirtyCVDNWomenDiabetes
                    - secondthrityCVDWomenCurrentSmoker
                    - 0.1166776 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                //thirty years CVD men UACR
                const thrityYearsCVDMenUacr =
                    - 1.398727
                    + 0.464491 * (age - 55) / 10
                    - 0.0998895 * carotSymbol
                    + 0.0757606 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1031778 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1990714 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2715816 * (Math.max(sbp, 110) - 130) / 20
                    + 0.4754637 * diabestValidation
                    + 0.2069672 * currentSmokerValidation
                    + 0.0331103 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0540474 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2189911 * htmlmedsValueValidation
                    - 0.0331044 * cholesteronTreatedValidation
                    - ((0.04534 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.1214535 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0483995 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0178997 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1059324 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2492861 * (age - 55) / 10) * diabestValidation)
                    - ((0.1561543 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.1012429 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + 0.1007571 * Math.log(this.uacr_range)
                //30 years CVD HBA1C Men
                var diabestValidationThrityYearsCVDMen = diabestValidation == 1 ? 0.0768169 * (this.HbA1C_range - 5.3) : 0.0777295 * (this.HbA1C_range - 5.3)
                const thrityYearsCVDMenHbA1c =
                    - 1.180767
                    + 0.4519873 * (age - 55) / 10
                    - 0.101624 * carotSymbol
                    + 0.0700456 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.0968005 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1923527 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2827043 * (Math.max(sbp, 110) - 130) / 20
                    + 0.3417152 * diabestValidation
                    + 0.2105272 * currentSmokerValidation
                    + 0.1113291 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0640135 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2334248 * htmlmedsValueValidation
                    - 0.0299421 * cholesteronTreatedValidation
                    - ((0.0393204 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.1228854 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0463737 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0184599 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1085744 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2208049 * (age - 55) / 10) * diabestValidation)
                    - ((0.1577978 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.1179375 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + diabestValidationThrityYearsCVDMen
                //Thirty year CVD SDP Men
                var thrityYearCVDMENSDIValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thrityYearCVDMENSDIValue = 0.0314626
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thrityYearCVDMENSDIValue = 0.2003953
                }
                let thrityYearCVDMenSDIMissing = this.SDIMissing == 1 ? 0.0927451 : 0
                const thrityYearsCVDMenSDP =
                    - 1.251031
                    + 0.437377 * (age - 55) / 10
                    - 0.104443 * carotSymbol
                    + 0.0812573 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1069199 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.2786727 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2729256 * (Math.max(sbp, 110) - 130) / 20
                    + 0.5279006 * diabestValidation
                    + 0.1878949 * currentSmokerValidation
                    + 0.0866569 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0594948 * (Math.max(egfr, 60) - 90) / -15
                    + 0.2028246 * htmlmedsValueValidation
                    - 0.0308404 * cholesteronTreatedValidation
                    - ((0.0283679 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.1439353 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0510854 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0150236 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1095448 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2561109 * (age - 55) / 10) * diabestValidation)
                    - ((0.1282945 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.1011023 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thrityYearCVDMENSDIValue
                    + thrityYearCVDMenSDIMissing
                //thrity year CVD Full
                var thirtyYearCVDSDIFullValue = 0
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thirtyYearCVDSDIFullValue = 0.0256704
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thirtyYearCVDSDIFullValue = 0.1887637
                }
                var diabetiesThirtyFullCVDFullValue = 0
                if (this.HbA1C_range !== '') {
                    diabetiesThirtyFullCVDFullValue = diabestValidation === 1 ? 0.0676202 * (this.HbA1C_range - 5.3) : 0.063409 * (this.HbA1C_range - 5.3)
                }
                let thrityYearsmensHeartFailureValueMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.089241 : 0
                let thrityYearsmensHeartFailureValueMissingUACR = this.uacr_range == "" ? 0.0710124 : 0.0894596 * Math.log(this.uacr_range)
                let thrityYearsmensHeartFailureValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0038783 : 0
                const thirtyYearCVDMenFull =
                    - 1.504558
                    + 0.4427595 * (age - 55) / 10
                    - 0.1064108 * carotSymbol
                    + 0.0629381 * (totalValuestchdl * 0.02586 - 3.5)
                    - 0.1015427 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.2542326 * (Math.min(sbp, 110) - 110) / 20
                    + 0.2549679 * (Math.max(sbp, 110) - 130) / 20
                    + 0.333835 * diabestValidation
                    + 0.1873833 * currentSmokerValidation
                    + 0.0246102 * (Math.min(egfr, 60) - 60) / -15
                    + 0.0552014 * (Math.max(egfr, 60) - 90) / -15
                    + 0.1979729 * htmlmedsValueValidation
                    - 0.0407714 * cholesteronTreatedValidation
                    - ((0.0365522 * (Math.max(sbp, 110) - 130) / 20) * htmlmedsValueValidation)
                    + ((0.1232822 * (totalValuestchdl * 0.02586 - 3.5)) * cholesteronTreatedValidation)
                    - 0.0441334 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5)
                    + 0.0177865 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3
                    - 0.1046657 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20
                    - ((0.2116113 * (age - 55) / 10) * diabestValidation)
                    - ((0.1277905 * (age - 55) / 10) * currentSmokerValidation)
                    - 0.0955922 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15
                    + thirtyYearCVDSDIFullValue
                    // + 0.0894596 * Math.log(this.uacr_range) 
                    + diabetiesThirtyFullCVDFullValue
                    + thrityYearsmensHeartFailureValueMissingSDI
                    + thrityYearsmensHeartFailureValueMissingUACR
                    + thrityYearsmensHeartFailureValueMissingHBAC1
                if ((this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '') || (this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '')) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMen) / (1 + Math.exp(thrityYearsCVDMen)) * 100).toFixed(1);
                    this.ModelName = "base model"
                }
                else if ((this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '') || (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMenUacr) / (1 + Math.exp(thrityYearsCVDMenUacr)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR"
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || (this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1)) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMenHbA1c) / (1 + Math.exp(thrityYearsCVDMenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c"
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMenSDP) / (1 + Math.exp(thrityYearsCVDMenSDP)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code"
                } else {
                    this.thrityYearsCVDMen = (Math.exp(thirtyYearCVDMenFull) / (1 + Math.exp(thirtyYearCVDMenFull)) * 100).toFixed(1);
                    this.ModelName = "full model"
                }
            }
        },
       
        validateIcon() {
            this.ageIcon = !this.ageIcon
        },
        validateAge(val) {
            if (val == 'info') {
                this.ageIcon = !this.ageIcon
            } else {
                if (this.age_range.value === "") {
                    this.isAgeRequried = true
                    this.ageValidation = false
                } else {
                    this.isAgeRequried = false
                }
                if (this.age_range.value && this.age_range.value < 30 || this.age_range.value > 79) {
                    this.ageValidation = true
                } else {
                    this.ageValidation = false
                }
            }
        },
        validateTotalCholesterol(val) {
            if (val == 'info') {
                this.totalCholesteronIcon = !this.totalCholesteronIcon
            }
            else {
                if (this.totalCholesterol_range.value == "") {
                    this.istotalCholesterolRequired = true;
                    this.totalCholesterolRangeValidation = false
                } else {
                    this.istotalCholesterolRequired = false
                }
                if (this.totalCholesterol_range.value && this.totalCholesterol_range.value < 130 || this.totalCholesterol_range.value > 320) {

                    this.totalCholesterolRangeValidation = true
                } else {
                    this.totalCholesterolRangeValidation = false
                }
            }
        },
        hdlCholesteronValidation(val) {
            if (val === 'info') {
                this.hdlCholesteronIcon = !this.hdlCholesteronIcon;
            } else {
                if (this.hdlCholesteron_range.value == "") {
                    this.ishdlCholesteronRequired = true;
                    this.hdlCholesteronValidate = false;
                } else {
                    this.ishdlCholesteronRequired = false
                }
                if (this.hdlCholesteron_range.value && this.hdlCholesteron_range.value < 20 || this.hdlCholesteron_range.value > 100) {
                    this.hdlCholesteronValidate = true;
                } else {
                    this.hdlCholesteronValidate = false;
                }
            }

        },
        sbpValidation(val) {
            if (val == 'info') {
                this.sbpIcon = !this.sbpIcon;
            } else {
                if (this.sbp_range.value == "") {
                    this.isSbpRequired = true;
                    this.spbValidate = false
                } else {
                    this.isSbpRequired = false
                }
                if (this.sbp_range.value && this.sbp_range.value < 90 || this.sbp_range.value > 200) {
                    this.spbValidate = true
                } else {
                    this.spbValidate = false
                }
            }

        },
        BMIValidation(val) {
            if (val == 'info') {
                this.bmiIcon = !this.bmiIcon
            } else {
                if (this.bmi_range.value == "") {
                    this.isbmiRequired = true;
                    this.validationBMI = false
                } else {
                    this.isbmiRequired = false
                }
                if (this.bmi_range.value && this.bmi_range.value < 18.5 || this.bmi_range.value > 39.9) {
                    this.validationBMI = true
                } else {
                    this.validationBMI = false
                }
            }
        },
        egfrValidation(val) {
            if (val == 'info') {
                this.egfrIcon = !this.egfrIcon
            } else {
                if (this.egfr_range.value == "") {
                    this.isegfrRequired = true;
                    this.validationegfr = false;
                } else {
                    this.isegfrRequired = false
                }
                if (this.egfr_range.value && this.egfr_range.value < 15 || this.egfr_range.value > 140) {
                    this.validationegfr = true
                } else {
                    this.validationegfr = false;
                }
            }

        },
        formValidate(e) {
            //age
            if (this.age_range.value == "") {
                this.isAgeRequried = true
            } else if (this.age_range.value && this.age_range.value < 30 || this.age_range.value > 79) {
                this.ageValidation = true
            }
            else {
                this.isAgeRequried = false
                this.ageValidation = false
            }
            //total cholesteron
            if (this.totalCholesterol_range.value == "") {
                this.istotalCholesterolRequired = true;
            } else if (this.totalCholesterol_range.value < 130 || this.totalCholesterol_range.value > 320) {
                this.totalCholesterolRangeValidation = true
            }
            else {
                this.istotalCholesterolRequired = false
                this.totalCholesterolRangeValidation = false
            }
            //hdl cholesteron
            if (this.hdlCholesteron_range.value == "") {
                this.ishdlCholesteronRequired = true;
            } else if (this.hdlCholesteron_range.value < 20 || this.hdlCholesteron_range.value > 100) {
                this.hdlCholesteronValidate = true;
            }
            else {
                this.ishdlCholesteronRequired = false
                this.hdlCholesteronValidate = false;
            }
            //sbp value
            if (this.sbp_range.value == "") {
                this.isSbpRequired = true;
            }
            else if (this.sbp_range.value < 90 || this.sbp_range.value > 200) {
                this.spbValidate = true
            }
            else {
                this.isSbpRequired = false
                this.spbValidate = false
            }
            //bmi range
            if (this.bmi_range.value == "") {
                this.isbmiRequired = true;
            } else if (this.bmi_range.value < 18.5 || this.bmi_range.value > 39.9) {
                this.validationBMI = true
            }
            else {
                this.isbmiRequired = false
                this.validationBMI = false
            }
            //egfr
            if (this.egfr_range.value == "") {
                this.isegfrRequired = true;
            } else if (this.egfr_range.value < 15 || this.egfr_range.value > 140) {
                this.validationegfr = true
            }
            else {
                this.isegfrRequired = false
                this.validationegfr = false
            }
           
            if(this.isShowUACR === 1 && this.uacr_range_front_end === ""){
                this.emptyUacrValidation = true
            }
            if(this.isShowHbA1C === 1 && this.HbA1C_range == ""){
                this.emptyHbA1CValidation = true;
            }
            if(this.isShowSID === 1 && this.SID_range == ""){
                this.SIDValidation = true;
            }
            
            //total cal
            if (!this.isegfrRequired && !this.validationegfr && !this.validationBMI && !this.isbmiRequired && !this.isSbpRequired && !this.spbValidate && !this.ishdlCholesteronRequired && !this.hdlCholesteronValidate && !this.istotalCholesterolRequired && !this.totalCholesterolRangeValidation && !this.isAgeRequried && !this.ageValidation) {
                this.totalValidation = true
                //this.SIDValidation =false
                if (this.uacr_range_front_end !== "" && this.uacrValidation === true) {
                    this.totalValidation = false
                }  else if (this.HbA1C_range !== "" && this.HbA1CValidation === true) {
                    this.totalValidation = false
                } else if(this.isShowSID === 1 && this.SID_range !== "" && this.SID_range.toString().length < 5) {
                    this.totalValidation = false
                    //this.emptySIDValidation = true
                    this.SIDValidation =true
                }  
            } else {
                this.totalValidation = false
                
            }
        },
        resetForm() {
            this.htmlmeds_range = "0"
            this.validationegfr = false
            this.isegfrRequired = false;
            this.egfrIcon = false;
            this.validationBMI = false;
            this.isbmiRequired = false;
            this.validationBMI = false;
            this.spbValidate = false;
            this.isSbpRequired = false;
            this.sbpIcon = false;
            this.hdlCholesteronValidate = false;
            this.ishdlCholesteronRequired = false;
            this.hdlCholesteronIcon = false;
            this.totalCholesterolRangeValidation = false;
            this.istotalCholesterolRequired = false;
            this.totalCholesteronIcon = false;
            this.ageIcon = false;
            this.ageValidation = false;
            this.isAgeRequried = false;
            this.totalThirtyYearsHeartFailureWomen = "";
            this.totalThirtyAscvdWomenValue = "";
            this.totalThirtyYearsCVDWomenValue = "";
            this.totalThirtyHearFailureMenValue = "";
            this.totalThirtyAscvdMenValue = "";
            this.thrityYearsCVDMen = "";
            this.totalCVDMenValue = "";
            this.totalCVDWomenValue = "";
            this.totalAscdMenValue = "";
            this.totalAscdWomenValue = "";
            this.totalHearFailureMenVlaue = '';
            this.totalHeartFailureWomenValue = '';
            this.totalResult = 0;
            this.sex_range = 0;
            this.diabetes_range = 0;
            this.currentSmoker_range = 0;
            this.htn_range = 0;
            this.cholesteronTreated_range = 0;
            this.uacr_range = 0;
            this.isAgeValidate = false;
            this.isMlvwtValidate = false;
            this.isLasizeValidate = false;
            this.isMaxlovtValidate = false;
            this.isMlvwtRequired = false;
            this.isLasizeRequired = false;
            this.isMaxlvotRequired = false;
            this.ageToolTip = true;
            this.mlvwtToolTip = true;
            this.lasizeToolTip = true;
            this.maxlvotToolTip = true;
            this.fhscdToolTip = true;
            this.nsvtToolTip = true;
            this.unexSyToolTip = true;
            this.ef50ToolTip = true;
            this.apAnToolTip = true;
            this.elgeToolTip = true;
            this.age_range.value = "";
            this.totalCholesterol_range.value = "";
            this.hdlCholesteron_range.value = "";
            this.sbp_range.value = "";
            this.bmi_range.value = "";
            this.egfr_range.value = "";
            this.diabetesIcon = false;
            this.currentSmokerIcon = false;
            this.htnMedsIcon = false;
            this.cholesteronTreatedIcon = false;
            this.bmiIcon = false;
            this.isShowSID = 0;
            this.isShowHbA1C = 0;
            this.isShowUACR = 0;
            this.HbA1C_range = '';
            this.SID_range = '';
            this.uacr_range = '';
            this.iconUacrValidation = false;
            this.iconHbA1CValidation = false;
            this.iconSIDValidation = false;
            this.uacr_range_front_end = ""
            this.SIDValidation = false;
            this.emptySIDValidation = false;
            this.iconSIDValidation = false;
            this.ModelName = ""
            this.totalValidation = false;
        }
    },
    watch: {
        sex_range(newVal, oldVal) {
            if (oldVal === 0) {
                this.totalCVDWomenValue = "";
                this.totalCVDMenValue = "";
                this.totalAscdWomenValue = "";
                this.totalAscdMenValue = "";
                this.totalHearFailureMenVlaue = "";
                this.totalHeartFailureWomenValue = "";
                //thirty year
                this.totalThirtyYearsHeartFailureWomen = "";
                this.totalThirtyAscvdWomenValue = "";
                this.totalThirtyYearsCVDWomenValue = "";
                this.totalThirtyHearFailureMenValue = "";
                this.totalThirtyAscvdMenValue = "";
                this.thrityYearsCVDMen = "";
                this.totalHeartFailureWomenValues = "";
                // this.SDIMissing = ""
                this.ModelName = ""
                this.sex_range = 1;
            } else if (oldVal === 1) {
                this.totalCVDWomenValue = "";
                this.totalCVDMenValue = "";
                this.totalAscdWomenValue = "";
                this.totalAscdMenValue = "";
                this.totalHearFailureMenVlaue = "";
                this.totalHeartFailureWomenValue = "";
                this.totalHeartFailureWomenValues = "";
                //thirty year
                this.totalThirtyYearsHeartFailureWomen = "";
                this.totalThirtyAscvdWomenValue = "";
                this.totalThirtyYearsCVDWomenValue = "";
                this.totalThirtyHearFailureMenValue = "";
                this.totalThirtyAscvdMenValue = "";
                this.thrityYearsCVDMen = "";
                this.sex_range = 0;
                this.ModelName = ""
            }
        },
        'age_range.value': {
            handler(newVal, oldVal) {
                if (oldVal >= 60) {
                    this.totalThirtyYearsHeartFailureWomen = "";
                    this.totalThirtyAscvdWomenValue = "";
                    this.totalThirtyYearsCVDWomenValue = "";
                    this.totalThirtyHearFailureMenValue = "";
                    this.totalThirtyAscvdMenValue = "";
                    this.thrityYearsCVDMen = "";
                }
            }
        },
        // isShowSID(nexVal, oldVal) {
        //     if (oldVal === 0) {
        //         this.totalCVDMenValue = ""
        //         this.thrityYearsCVDMen = ""
        //         this.totalAscdMenValue = ""
        //         this.totalThirtyAscvdMenValue = ""
        //         this.totalHearFailureMenVlaue = ""
        //         this.totalThirtyHearFailureMenValue = ""
        //         this.totalCVDWomenValue = ""
        //         this.totalThirtyYearsCVDWomenValue = ""
        //         this.totalAscdWomenValue = ""
        //         this.totalThirtyAscvdWomenValue = ""
        //         this.totalHeartFailureWomenValues = ""
        //         this.totalThirtyYearsHeartFailureWomen = ""
        //         //this.SIDValidation =true
        //     } else {
        //         //this.SIDValidation =false
        //     }
        // }
    }
};
</script>
<style lang="scss" scoped>
@import "~@/sass/base";

textarea.form-control,
.c-aha-form textarea {
    padding: 10px;
    min-height: 100px;
}

.lower {
    margin-top: 45px;
}

@include media-breakpoint-up(sm) {
    .lower {
        margin-top: 50px;
    }
}

a.icon {
    width: 30px;
    height: 30px;
    background: #c10e21;
    border-radius: 50%;
    border: thin solid #c10e21;
    color: #fff;
    font-weight: bold;
    display: inline-flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.modalName {
    color: #c10e21;
    font-weight: 400;
    font-size: 16px;
}

a.icon:hover {
    color: #fff;
}

#risk,
#recommendation,
.toolTip {
    background-color: #e9ecef;
    opacity: 1;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-clip: padding-box;
    border: 1px solid #c4cacf;
    border-radius: 2px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-space-result {
    margin-top: -10px;
}

.redClass {
    color: #E60F00;
    font-weight: 600;
}

.oragneClass {
    color: #AD6500;
    font-weight: 600;
}

.greenClass {
    color: #008A02;
    font-weight: 600 !important;
}

.lightRedClass {
    color: #CC4B00;
    font-weight: 600;
}

.normalClass {
    color: #222328
}

.custom-tooltip {
    margin-left: 17px;
}

.custom-space {
    margin-left: -5px;
    margin-right: 30px;
}

.custom-result-radio-btn {
    margin-left: -5px;
    margin-right: 30px;
}
</style>





// WEBPACK FOOTER //
// src/app/components/phd/ckm-risk-calculator.vue